import type { LocaleMessageBundle } from '../../types'

export const staffMessages: LocaleMessageBundle = {
  vi: {
    'staff.role.permission.codes.staff_attendance.online_punch': 'Chấm công trực tuyến',
    'staff.role.permission.codes.staff_attendance.punch': 'Thực hiện chấm công',
    'staff.actions.previousYear': 'Năm trước',
    'staff.actions.nextYear': 'Năm sau',
    'staff.actions.more': 'Thao tác',
    'staff.import.clearFile': 'Bỏ tệp đã chọn',
    'staff.role.permission.groups.face_profile': 'Khuôn mặt chấm công',
    'staff.role.permission.codes.staff_attendance.confirm_self': 'Xác nhận điểm danh của bản thân',
    'staff.role.permission.codes.staff_attendance.confirm_for_staff':
      'Xác nhận điểm danh cho nhân viên',
    'staff.role.permission.codes.staff_leave.view_self': 'Xem nghỉ phép của bản thân',
    'staff.role.permission.codes.staff_leave.request': 'Yêu cầu nghỉ phép',
    'staff.role.permission.codes.staff_leave.manage': 'Quản lý và duyệt nghỉ phép',
    'staff.role.permission.codes.staff_overtime.view_self': 'Yêu cầu và xem tăng ca của bản thân',
    'staff.role.permission.codes.staff_overtime.manage': 'Quản lý và duyệt tăng ca',
    'staff.role.permission.codes.staff_allowance.view': 'Xem phụ cấp',
    'staff.role.permission.codes.staff_allowance.manage': 'Quản lý phụ cấp',
    'staff.role.permission.codes.staff_salary_advance.request': 'Yêu cầu tạm ứng lương',
    'staff.role.permission.codes.staff_salary_advance.view': 'Xem tạm ứng lương',
    'staff.role.permission.codes.staff_salary_advance.manage': 'Quản lý và duyệt tạm ứng lương',
    'staff.role.permission.codes.staff_insurance.view': 'Xem bảo hiểm nhân viên',
    'staff.role.permission.codes.staff_insurance.manage': 'Quản lý bảo hiểm nhân viên',
    'staff.role.permission.codes.staff_payroll.view_self': 'Xem phiếu lương của bản thân',
    'staff.role.permission.codes.staff_payroll.respond_self':
      'Xác nhận hoặc yêu cầu sửa phiếu lương của bản thân',
    'staff.role.permission.codes.staff_payroll.send': 'Gửi phiếu lương cho nhân viên',
    'staff.role.permission.codes.staff_payroll.view': 'Xem bảng lương',
    'staff.role.permission.codes.staff_payroll.create': 'Tạo bảng lương',
    'staff.role.permission.codes.staff_payroll.review': 'Kiểm tra bảng lương',
    'staff.role.permission.codes.staff_payroll.finalize': 'Chốt bảng lương',
    'staff.role.permission.codes.staff_payroll.pay': 'Ghi nhận thanh toán lương',
    'staff.role.permission.codes.staff_payroll.adjust': 'Điều chỉnh phiếu lương nháp',
    'staff.role.permission.codes.staff_payroll.policy_manage': 'Cấu hình chính sách lương',
    'staff.role.permission.codes.staff_attendance.adjust_checkin_override':
      'Điều chỉnh giờ vào của nhân viên',
    'staff.role.permission.codes.staff_attendance.device_view': 'Xem thiết bị chấm công',
    'staff.role.permission.codes.staff_attendance.device_manage': 'Quản lý thiết bị chấm công',
    'staff.role.permission.codes.staff_attendance.device_event_review':
      'Kiểm tra sự kiện thiết bị chấm công',
    'staff.role.permission.codes.staff.face.view_status': 'Xem trạng thái khuôn mặt chấm công',
    'staff.role.permission.codes.staff.face.manage': 'Quản lý khuôn mặt chấm công',
    'staff.role.permission.codes.staff_shift.manage_past': 'Quản lý phân ca trong quá khứ',
    'staff.role.permission.groups.contract': 'Hợp đồng lao động',
    'staff.role.permission.groups.contract_type': 'Loại hợp đồng',
    'staff.role.permission.resources.staff_contract': 'hợp đồng lao động',
    'staff.role.permission.actions.send': 'Gửi duyệt',
    'staff.role.permission.actions.sign': 'Ký',
    'staff.role.permission.actions.renew': 'Gia hạn',
    'staff.role.permission.actions.terminate': 'Chấm dứt',
    'staff.role.permission.codes.staff_contract.view': 'Xem hợp đồng lao động',
    'staff.role.permission.codes.staff_contract.view_self': 'Xem hợp đồng của bản thân',
    'staff.role.permission.codes.staff_contract.create': 'Tạo hợp đồng lao động',
    'staff.role.permission.codes.staff_contract.update': 'Cập nhật hợp đồng lao động',
    'staff.role.permission.codes.staff_contract.delete': 'Hủy hợp đồng lao động',
    'staff.role.permission.codes.staff_contract.send': 'Gửi hợp đồng lao động duyệt',
    'staff.role.permission.codes.staff_contract.approve': 'Duyệt hợp đồng lao động',
    'staff.role.permission.codes.staff_contract.reject': 'Từ chối hợp đồng lao động',
    'staff.role.permission.codes.staff_contract.sign': 'Ký hợp đồng lao động',
    'staff.role.permission.codes.staff_contract.renew': 'Gia hạn hợp đồng lao động',
    'staff.role.permission.codes.staff_contract.terminate': 'Chấm dứt hợp đồng lao động',
    'staff.role.permission.codes.staff_contract.type_view': 'Xem loại hợp đồng',
    'staff.role.permission.codes.staff_contract.type_create': 'Tạo loại hợp đồng',
    'staff.role.permission.codes.staff_contract.type_update': 'Cập nhật loại hợp đồng',
    'staff.role.permission.codes.staff_contract.type_delete': 'Xóa loại hợp đồng',
    'staff.role.permission.groups.payroll': 'Bảng lương',
    'staff.role.permission.groups.leave': 'Nghỉ phép',
    'staff.role.permission.groups.overtime': 'Tăng ca',
    'staff.role.permission.groups.allowance': 'Phụ cấp',
    'staff.role.permission.groups.salary_advance': 'Tạm ứng lương',
    'staff.role.permission.groups.insurance': 'Bảo hiểm',
    'staff.role.permission.groups.attendance_device': 'Thiết bị chấm công',
    'staff.fields.department': 'Bộ phận',
    'staff.department.quickCreate': 'Thêm nhanh bộ phận',
    'staff.department.name': 'Tên bộ phận',
    'staff.department.description': 'Mô tả',
    'staff.department.create': 'Thêm bộ phận',
    'staff.department.update': 'Cập nhật bộ phận',
    'staff.department.code': 'Mã bộ phận',
    'staff.department.staffCount': 'Tổng nhân viên',
    'staff.department.activeStaff': 'Đang hoạt động',
    'staff.department.status': 'Trạng thái',
    'staff.department.sortOrder': 'Thứ tự',
    'staff.department.search': 'Tìm mã hoặc tên',
    'staff.department.sortOrderInteger': 'Thứ tự phải là một số nguyên',
    'staff.department.deleteConfirm': 'Xóa bộ phận {name}?',
    'staff.department.mobileStaffCount': 'Tổng: {count} nhân viên',
    'staff.department.mobileActiveStaff': 'Đang hoạt động: {count}',
    'staff.department.errors.hasStaff':
      'Không thể xóa bộ phận vì đang có {count} nhân viên thuộc bộ phận này. Vui lòng chuyển nhân viên sang bộ phận khác trước khi xóa.',
    'staff.department.notifications.createFailed': 'Thêm bộ phận không thành công.',
    'staff.department.notifications.updateFailed': 'Cập nhật bộ phận không thành công.',
    'staff.department.notifications.deleteFailed': 'Xóa bộ phận không thành công.',
    'staff.model': 'Nhân viên',
    'staff.title': 'Quản lý nhân viên',
    'staff.sections.login': 'Thông tin đăng nhập',
    'staff.sections.profile': 'Thông tin cá nhân',
    'staff.sections.face': 'Khuôn mặt chấm công AI06',
    'staff.sections.salary': 'Thiết lập lương',
    'staff.sections.allowances': 'Phụ cấp áp dụng',
    'staff.tabs.profile': 'Thông tin nhân viên',
    'staff.tabs.compensation': 'Thiết lập lương',
    'staff.nav.label': 'Nhóm thông tin nhân viên',
    'staff.nav.general': 'Thông tin chung',
    'staff.nav.hrProfile': 'Hồ sơ nhân sự',
    'staff.nav.finance': 'Tài chính',
    'staff.nav.documents': 'Tài liệu',
    'staff.sections.globalRoles': 'Vai trò toàn hệ thống',
    'staff.sections.branchAssignments': 'Phân chi nhánh',
    'staff.sections.faceDevices': 'Đồng bộ thiết bị FaceID',
    'staff.fields.employeeCode': 'Mã nhân viên',
    'staff.fields.fullName': 'Họ và tên',
    'staff.fields.username': 'Tên đăng nhập',
    'staff.fields.password': 'Mật khẩu',
    'staff.fields.phone': 'Điện thoại',
    'staff.fields.email': 'Email',
    'staff.fields.avatar': 'Ảnh đại diện',
    'staff.fields.faceImage': 'Ảnh nhận diện khuôn mặt',
    'staff.fields.gender': 'Giới tính',
    'staff.fields.birthday': 'Ngày sinh',
    'staff.fields.address': 'Địa chỉ',
    'staff.fields.salaryType': 'Hình thức lương',
    'staff.fields.salaryAmount': 'Mức lương',
    'staff.fields.socialInsuranceBase': 'Mức đóng bảo hiểm xã hội',
    'staff.salary.socialInsuranceHint':
      'Mức làm căn cứ đóng bảo hiểm. Để 0 nếu chưa áp dụng; phiếu lương khấu trừ BHXH 8% và các khoản được chọn bên dưới.',
    'staff.salary.healthInsuranceOption': 'BHYT (nhân viên đóng 1,5%)',
    'staff.salary.unemploymentInsuranceOption': 'BHTN (nhân viên đóng 1%)',
    'staff.salary.types.fixed': 'Lương cố định theo tháng',
    'staff.salary.types.daily': 'Lương theo ngày',
    'staff.salary.types.hourly': 'Lương theo giờ',
    'staff.salary.amountLabels.fixed': 'Mức lương tháng',
    'staff.salary.amountLabels.daily': 'Mức lương mỗi ngày',
    'staff.salary.amountLabels.hourly': 'Mức lương mỗi giờ',
    'staff.validation.salaryAmountPositive': 'Mức lương phải lớn hơn 0.',
    'staff.allowances.empty': 'Nhân viên chưa được áp dụng loại phụ cấp nào.',
    'staff.allowances.type': 'Loại phụ cấp',
    'staff.allowances.amountOverride': 'Mức riêng (để trống dùng mức mặc định)',
    'staff.allowances.startsOn': 'Áp dụng từ ngày',
    'staff.allowances.endsOn': 'Áp dụng đến ngày',
    'staff.allowances.note': 'Ghi chú',
    'staff.allowances.remove': 'Bỏ phụ cấp',
    'staff.allowances.conditionSummary': 'Điều kiện tính: {basis}',
    'staff.allowances.basis.fixed_monthly': 'Cố định theo tháng',
    'staff.allowances.basis.worked_day': 'Theo ngày có đi làm',
    'staff.allowances.basis.completed_shift': 'Theo ca làm hoàn tất',
    'staff.allowances.basis.worked_hour': 'Theo giờ làm thực tế',
    'staff.fields.status': 'Trạng thái',
    'staff.fields.globalRoles': 'Vai trò toàn hệ thống',
    'staff.fields.branches': 'Chi nhánh',
    'staff.fields.branch': 'Chi nhánh',
    'staff.fields.branchRole': 'Vai trò tại chi nhánh',
    'staff.fields.defaultBranch': 'Chi nhánh mặc định',
    'staff.fields.faceDeviceSyncMode': 'Phạm vi đồng bộ FaceID',
    'staff.fields.faceDevices': 'Thiết bị được phép',
    'staff.fields.faceCaptureDevices': 'Thiết bị cần lấy lại khuôn mặt',
    'staff.faceDevices.all': 'Tất cả thiết bị tại chi nhánh đã gán',
    'staff.faceDevices.selected': 'Chỉ các thiết bị được chọn',
    'staff.faceDevices.allHint':
      'Nhân viên sẽ tự động được đồng bộ tới mọi thiết bị đang hoạt động tại các chi nhánh đã gán.',
    'staff.faceDevices.captureHint':
      'Sau khi lưu, thiết bị được chọn sẽ yêu cầu nhân viên đứng trước máy để thu khuôn mặt mới.',
    'staff.fields.assignmentCount': 'Số chi nhánh',
    'staff.fields.lastLogin': 'Đăng nhập gần nhất',
    'staff.fields.mustChangePassword': 'Yêu cầu đổi mật khẩu khi đăng nhập lần đầu',
    'staff.actions.add': 'Thêm nhân viên',
    'staff.actions.create': 'Thêm nhân viên',
    'staff.actions.update': 'Sửa nhân viên',
    'staff.actions.submitCreate': 'Thêm nhân viên',
    'staff.actions.submitUpdate': 'Sửa nhân viên',
    'staff.actions.cancel': 'Đóng',
    'staff.actions.delete': 'Xóa',
    'staff.actions.deactivate': 'Nghỉ việc',
    'staff.actions.restore': 'Khôi phục',
    'staff.actions.resetPassword': 'Đặt lại mật khẩu',
    'staff.actions.confirmPassword': 'Xác nhận mật khẩu',
    'staff.actions.generatePassword': 'Tạo mật khẩu',
    'staff.actions.import': 'Nhập Excel',
    'staff.actions.export': 'Xuất Excel',
    'staff.actions.deleteTitle': 'Xóa nhân viên',
    'staff.dialog.createSubtitle': 'Nhập thông tin nhân viên để thêm vào hệ thống',
    'staff.dialog.updateSubtitle': 'Cập nhật thông tin nhân viên',
    'staff.import.title': 'Import danh sách nhân viên',
    'staff.import.subtitle': 'Tải file mẫu, nhập dữ liệu và kiểm tra trước khi thêm nhân viên',
    'staff.import.loadingCatalog': 'Đang tải danh mục bộ phận, chi nhánh và vai trò...',
    'staff.import.templateTitle': 'Tải file Excel mẫu',
    'staff.import.templateDescription':
      'File mẫu có đầy đủ cột dữ liệu, hướng dẫn và danh mục mã đang dùng trong hệ thống.',
    'staff.import.downloadTemplate': 'Tải file mẫu',
    'staff.import.requiredLegend': 'Trường bắt buộc.',
    'staff.import.conditionalLegend':
      'Bắt buộc nếu nhân viên không có vai trò OWNER hoặc SUPER_ADMIN.',
    'staff.import.notes.password': 'Mật khẩu phải có ít nhất 6 ký tự.',
    'staff.import.notes.unique':
      'Tên đăng nhập, mã nhân viên, email và điện thoại không được trùng.',
    'staff.import.notes.values':
      'Ngày sinh dùng YYYY-MM-DD; giới tính male/female; trạng thái active/inactive/locked.',
    'staff.import.notes.department':
      'Mã bộ phận là bắt buộc và phải chọn từ sheet Danh mục trong file mẫu.',
    'staff.import.notes.assignment':
      'Phân chi nhánh theo cú pháp MÃ_CHI_NHÁNH|MÃ_VAI_TRÒ; dùng dấu chấm phẩy cho nhiều chi nhánh.',
    'staff.import.notes.security':
      'File chứa mật khẩu ban đầu là dữ liệu nhạy cảm; hãy bảo quản và xóa file sau khi sử dụng.',
    'staff.import.notes.avatar': 'Ảnh đại diện được bổ sung sau khi import nhân viên.',
    'staff.import.fileTitle': 'Chọn file cần import',
    'staff.import.fileDescription':
      'Hệ thống sẽ kiểm tra từng dòng và chỉ xử lý những dòng hợp lệ.',
    'staff.import.chooseFile': 'Chọn file Excel',
    'staff.import.supportedFormats': 'Hỗ trợ .xlsx, .xls; tối đa 5 MB',
    'staff.import.summary.total': 'Tổng: {count}',
    'staff.import.summary.valid': 'Hợp lệ: {count}',
    'staff.import.summary.invalid': 'Có lỗi: {count}',
    'staff.import.errorListTitle': 'Các dòng cần kiểm tra',
    'staff.import.rowLabel': 'Dòng {row}',
    'staff.import.process': 'Import {count} nhân viên',
    'staff.import.result':
      'Đã import thành công {success} nhân viên; {failed} dòng không thành công.',
    'staff.import.errors.invalidFileType': 'Chỉ hỗ trợ file Excel định dạng .xlsx hoặc .xls.',
    'staff.import.errors.fileTooLarge': 'Dung lượng file không được vượt quá 5 MB.',
    'staff.import.errors.noRows': 'File không có dòng dữ liệu nhân viên.',
    'staff.import.errors.cannotRead':
      'Không thể đọc file. Vui lòng dùng đúng file mẫu và không thay đổi tên cột.',
    'staff.import.errors.templateDownloadFailed':
      'Không thể tải file mẫu từ máy chủ. Vui lòng thử lại.',
    'staff.import.errors.rowFailed': 'Không thể thêm nhân viên.',
    'staff.export.error': 'Không thể export danh sách nhân viên. Vui lòng thử lại.',
    'staff.dialog.avatarHint':
      'JPG, PNG hoặc WebP (tối đa 5MB). Ảnh này cũng được dùng để nhận diện FaceID.',
    'staff.dialog.faceHint': 'JPG hoặc PNG, tối đa 10MB',
    'staff.dialog.faceDescription':
      'Ảnh được lưu riêng tư và tự động xếp hàng đồng bộ xuống thiết bị FaceID của tenant.',
    'staff.deleteConfirm': 'Bạn có chắc muốn xóa nhân viên {name}?',
    'staff.deleteHint':
      'Nhân viên đã phát sinh dữ liệu chỉ có thể chuyển sang trạng thái Nghỉ việc.',
    'staff.status.active': 'Hoạt động',
    'staff.status.inactive': 'Tạm ngưng',
    'staff.status.locked': 'Đã khóa',
    'staff.gender.male': 'Nam',
    'staff.gender.female': 'Nữ',
    'staff.gender.other': 'Khác',
    'staff.validation.birthdayMinAge': 'Nhân viên phải trên {age} tuổi',
    'staff.validation.birthdayMinAgeOrEqual': 'Nhân viên phải lớn hơn hoặc bằng {age} tuổi',
    'staff.validation.birthdayFuture': 'Ngày sinh không được ở tương lai',
    'staff.validation.branchRequired':
      'Nhân viên không có vai trò toàn quyền toàn hệ thống phải được gán ít nhất một chi nhánh',
    'staff.validation.branchRoleRequired': 'Vui lòng chọn vai trò cho mỗi chi nhánh đã chọn',
    'staff.validation.defaultBranchRequired': 'Vui lòng chọn một chi nhánh mặc định',
    'staff.placeholders.autoCode': 'Tự sinh nếu để trống',
    'staff.errors.saveFailed': 'Không thể lưu nhân viên. Vui lòng thử lại.',
    'staff.errors.avatarUploadFailed': 'Không thể tải ảnh đại diện. Vui lòng thử lại.',
    'staff.errors.faceUploadFailed': 'Không thể tải ảnh khuôn mặt. Vui lòng thử lại.',
    'staff.errors.faceImageInvalid': 'Ảnh khuôn mặt phải là JPG hoặc PNG và không quá 10MB.',
    'staff.errors.roleLoadFailed': 'Không thể tải danh sách vai trò.',
    'staff.role.title': 'Phân quyền',
    'staff.role.fields.code': 'Mã vai trò',
    'staff.role.fields.name': 'Tên vai trò',
    'staff.role.fields.scope': 'Phạm vi',
    'staff.role.fields.status': 'Trạng thái',
    'staff.role.fields.permissions': 'Số quyền',
    'staff.role.fields.staffCount': 'Nhân viên',
    'staff.filters.role': 'Vai trò',
    'staff.filters.branch': 'Chi nhánh',
    'staff.role.filters.search': 'Tìm vai trò',
    'staff.role.actions.permissions': 'Phân quyền',
    'staff.role.actions.savePermissions': 'Lưu phân quyền',
    'staff.role.permissionsDialog.title': 'Chọn quyền cho vai trò',
    'staff.role.permissionsDialog.searchLabel': 'Tìm quyền',
    'staff.role.permissionsDialog.searchPlaceholder': 'Nhập tên hoặc mã quyền',
    'staff.role.permissionsDialog.moduleLabel': 'Nhóm chức năng',
    'staff.role.permissionsDialog.allModules': 'Tất cả nhóm chức năng',
    'staff.role.permissionsDialog.selected': 'quyền đã chọn',
    'staff.role.permissionsDialog.resultCount': 'Hiển thị {count} quyền phù hợp',
    'staff.role.permissionsDialog.relatedPermission': 'Quyền liên quan',
    'staff.role.permissionsDialog.relatedTitle': 'Quyền liên quan',
    'staff.role.permissionsDialog.relatedHint':
      'Các quyền từ nhóm khác cần thiết để sử dụng đầy đủ chức năng trong mục đang lọc.',
    'staff.role.permissionsDialog.presets.title': 'Mẫu quyền gợi ý của hệ thống',
    'staff.role.permissionsDialog.presets.hint':
      'Chọn mẫu theo vị trí công việc để thiết lập nhanh danh sách quyền phù hợp.',
    'staff.role.permissionsDialog.presets.editable': 'Có thể tùy chỉnh sau khi áp dụng',
    'staff.role.permissionsDialog.presets.apply': 'Áp dụng mẫu quyền',
    'staff.role.permissionsDialog.presets.replaceWarning':
      'Áp dụng sẽ thay thế danh sách quyền đang chọn. Thay đổi chỉ được lưu khi bạn bấm Lưu quyền.',
    'staff.role.permissionsDialog.presets.permissionCount': '{count} quyền',
    'staff.role.permissionsDialog.presets.salesStaff.title': 'Nhân viên bán hàng',
    'staff.role.permissionsDialog.presets.salesStaff.description':
      'Bán hàng/POS, đơn hàng, khách hàng, thu tiền, chốt ca và chấm công cá nhân.',
    'staff.role.permissionsDialog.presets.hrManager.title': 'Quản lý nhân sự',
    'staff.role.permissionsDialog.presets.hrManager.description':
      'Nhân viên, phòng ban, ca làm, lịch làm việc, chấm công và vai trò.',
    'staff.role.permissionsDialog.emptyTitle': 'Không tìm thấy quyền',
    'staff.role.permissionsDialog.emptyHint': 'Thử từ khóa khác hoặc chọn lại nhóm chức năng.',
    'staff.role.permission.namePattern': '{action} {resource}',
    'staff.role.permission.fullAccess': 'Toàn quyền hệ thống',
    'staff.role.permission.resources.brand': 'thương hiệu',
    'staff.role.permission.resources.category': 'danh mục sản phẩm',
    'staff.role.permission.resources.location': 'vị trí kho',
    'staff.role.permission.resources.unit': 'đơn vị tính',
    'staff.role.permission.resources.sale_return': 'trả hàng / đổi hàng',
    'staff.role.permission.actions.view': 'Xem',
    'staff.role.permission.actions.view_self': 'Xem của bản thân',
    'staff.role.permission.actions.view_all': 'Xem tất cả',
    'staff.role.permission.actions.create': 'Tạo',
    'staff.role.permission.actions.update': 'Cập nhật',
    'staff.role.permission.actions.delete': 'Xóa',
    'staff.role.permission.actions.submit': 'Gửi',
    'staff.role.permission.actions.approve': 'Duyệt',
    'staff.role.permission.actions.reject': 'Từ chối',
    'staff.role.permission.actions.export': 'Xuất dữ liệu',
    'staff.role.permission.actions.complete': 'Hoàn tất',
    'staff.role.permission.actions.cancel': 'Hủy',
    'staff.role.permission.actions.confirm': 'Xác nhận',
    'staff.role.permission.actions.pay': 'Thanh toán',
    'staff.role.permission.actions.assign': 'Phân ca',
    'staff.role.permission.actions.unassign': 'Hủy phân ca',
    'staff.role.permission.actions.manage': 'Quản lý',
    'staff.role.permission.actions.manage_past': 'Quản lý dữ liệu quá khứ',
    'staff.role.permission.actions.punch': 'Chấm công',
    'staff.role.permission.actions.settings': 'Cấu hình',
    'staff.role.permission.actions.post': 'Ghi sổ',
    'staff.role.permission.actions.receive': 'Tiếp nhận',
    'staff.role.permission.actions.balance': 'Cân bằng',
    'staff.role.permission.actions.merge': 'Gộp',
    'staff.role.permission.actions.activate': 'Kích hoạt',
    'staff.role.permission.actions.archive': 'Lưu trữ',
    'staff.role.permission.actions.check_in': 'Nhận khách',
    'staff.role.permission.actions.assign_staff': 'Gán nhân viên',
    'staff.role.permission.actions.switch': 'Chuyển',
    'staff.role.permission.actions.view_sensitive': 'Xem dữ liệu nhạy cảm',
    'staff.role.permission.actions.manage_retention': 'Quản lý thời hạn lưu trữ',
    'staff.role.permission.actions.email': 'Gửi email',
    'staff.role.permission.actions.email_custom_recipient': 'Đổi người nhận email',
    'staff.role.permission.actions.view_all_branches': 'Xem tất cả chi nhánh',
    'staff.role.permission.actions.point_redeem': 'Đổi điểm',
    'staff.role.permission.actions.point_manual_adjust': 'Điều chỉnh điểm',
    'staff.role.permission.modules.system': 'Hệ thống',
    'staff.role.permission.modules.dashboard': 'Tổng quan',
    'staff.role.permission.modules.report': 'Báo cáo',
    'staff.role.permission.modules.pos': 'Bán hàng POS',
    'staff.role.permission.modules.sale': 'Bán hàng',
    'staff.role.permission.modules.sales_channel': 'Kênh bán hàng',
    'staff.role.permission.modules.sales_invoice': 'Hóa đơn bán hàng',
    'staff.role.permission.modules.sale_return': 'Trả hàng / Đổi hàng',
    'staff.role.permission.modules.sales_order': 'Đơn bán hàng',
    'staff.role.permission.modules.sales_area': 'Khu vực bán hàng',
    'staff.role.permission.modules.sales_table': 'Bàn bán hàng',
    'staff.role.permission.modules.branch': 'Chi nhánh',
    'staff.role.permission.modules.setting': 'Thiết lập',
    'staff.role.permission.modules.delivery_partner': 'Đối tác giao hàng',
    'staff.role.permission.modules.cash_book': 'Sổ quỹ',
    'staff.role.permission.modules.bill': 'Hóa đơn',
    'staff.role.permission.modules.product': 'Sản phẩm',
    'staff.role.permission.modules.price_list': 'Bảng giá',
    'staff.role.permission.modules.promotion': 'Khuyến mãi',
    'staff.role.permission.modules.area_pricing': 'Giá theo khu vực',
    'staff.role.permission.modules.table_pricing': 'Giá theo bàn',
    'staff.role.permission.modules.table_session': 'Phiên sử dụng bàn',
    'staff.role.permission.modules.booking': 'Đặt bàn',
    'staff.role.permission.modules.inventory': 'Kho hàng',
    'staff.role.permission.modules.supplier': 'Nhà cung cấp',
    'staff.role.permission.modules.customer': 'Khách hàng',
    'staff.role.permission.modules.staff': 'Nhân viên',
    'staff.role.permission.groups.all': 'Toàn hệ thống',
    'staff.role.permission.groups.dashboard': 'Tổng quan',
    'staff.role.permission.groups.branch': 'Chi nhánh',
    'staff.role.permission.groups.staff': 'Nhân viên',
    'staff.role.permission.groups.department': 'Phòng ban',
    'staff.role.permission.groups.work_shift': 'Ca làm việc',
    'staff.role.permission.groups.schedule': 'Phân ca',
    'staff.role.permission.groups.attendance': 'Chấm công',
    'staff.role.permission.groups.role': 'Vai trò',
    'staff.role.permission.groups.permission': 'Quyền truy cập',
    'staff.role.permission.groups.product': 'Sản phẩm',
    'staff.role.permission.groups.product_catalog': 'Danh mục sản phẩm',
    'staff.role.permission.groups.location': 'Vị trí kho',
    'staff.role.permission.groups.area': 'Khu vực',
    'staff.role.permission.groups.table': 'Bàn',
    'staff.role.permission.groups.setting': 'Thiết lập chung',
    'staff.role.permission.groups.system': 'Thiết lập hệ thống',
    'staff.role.permission.groups.activity_log': 'Lịch sử hệ thống',
    'staff.role.permission.groups.print_templates': 'Mẫu in',
    'staff.role.permission.groups.payment_methods': 'Phương thức thanh toán',
    'staff.role.permission.groups.delivery_partner': 'Đối tác giao hàng',
    'staff.role.permission.groups.cash_book': 'Sổ quỹ',
    'staff.role.permission.groups.cash_transaction': 'Thu/chi',
    'staff.role.permission.groups.transaction_type': 'Loại giao dịch',
    'staff.role.permission.groups.bill': 'Hóa đơn',
    'staff.role.permission.groups.pricing': 'Bảng giá',
    'staff.role.permission.groups.voucher': 'Mã ưu đãi',
    'staff.role.permission.groups.area_pricing': 'Giá theo khu vực',
    'staff.role.permission.groups.table_pricing': 'Giá theo bàn',
    'staff.role.permission.groups.table_session': 'Phiên sử dụng bàn',
    'staff.role.permission.groups.booking': 'Đặt bàn',
    'staff.role.permission.groups.inventory': 'Kho hàng',
    'staff.role.permission.groups.stock': 'Tồn kho',
    'staff.role.permission.groups.inventory_check': 'Kiểm kê kho',
    'staff.role.permission.groups.opening_stock': 'Tồn kho đầu kỳ',
    'staff.role.permission.groups.purchase_receipt': 'Nhập hàng',
    'staff.role.permission.groups.purchase_return': 'Trả hàng nhập',
    'staff.role.permission.groups.stock_transfer': 'Chuyển kho',
    'staff.role.permission.groups.supplier': 'Nhà cung cấp',
    'staff.role.permission.groups.debt': 'Công nợ',
    'staff.role.permission.groups.payment': 'Thanh toán',
    'staff.role.permission.groups.customer': 'Khách hàng',
    'staff.role.permission.groups.group': 'Nhóm khách hàng',
    'staff.role.permission.groups.tier': 'Hạng thành viên',
    'staff.role.permission.groups.receipt': 'Phiếu thu',
    'staff.role.permission.groups.loyalty': 'Tích điểm thành viên',
    'staff.role.permission.groups.pos': 'Bán hàng POS',
    'staff.role.permission.groups.kitchen': 'Bếp và quầy bar',
    'staff.role.permission.groups.invoice': 'Hóa đơn bán hàng',
    'staff.role.permission.groups.sale_return': 'Trả hàng / Đổi hàng',
    'staff.role.permission.groups.order': 'Đơn bán hàng',
    'staff.role.permission.groups.channel': 'Kênh bán hàng',
    'staff.role.permission.groups.channel_products': 'Sản phẩm trên kênh',
    'staff.role.permission.groups.online_sales': 'Bán online',
    'staff.role.permission.groups.shift_revenue': 'Doanh thu ca',
    'staff.role.permission.groups.shift_closing': 'Báo cáo chốt ca',
    'staff.role.form.createTitle': 'Thêm vai trò',
    'staff.role.form.editTitle': 'Sửa vai trò',
    'staff.role.fields.description': 'Mô tả',
    'staff.role.status.active': 'Hoạt động',
    'staff.role.status.inactive': 'Tạm ngưng',
    'staff.role.placeholders.code': 'Ví dụ: STORE_MANAGER',
    'staff.role.placeholders.name': 'Nhập tên vai trò',
    'staff.role.actions.create': 'Thêm vai trò',
    'staff.role.actions.update': 'Lưu thay đổi',
    'staff.role.deleteDialog.title': 'Xác nhận xóa vai trò',
    'staff.role.deleteDialog.message':
      'Bạn đang xóa vai trò “{name}”. Thao tác này không thể hoàn tác.',
    'staff.role.deleteDialog.inUse':
      'Không thể xóa vai trò này vì đang được gán cho nhân viên. Vui lòng gỡ vai trò khỏi tất cả nhân viên và chi nhánh trước khi xóa.',
    'staff.role.deleteDialog.reason': 'Lý do xóa',
    'staff.role.deleteDialog.reasonPlaceholder': 'Nhập lý do xóa vai trò',
    'staff.role.deleteDialog.reasonHint': 'Bắt buộc, tối thiểu 3 ký tự và tối đa 500 ký tự.',
    'staff.role.validation.codeRequired': 'Vui lòng nhập mã vai trò.',
    'staff.role.validation.codeMax': 'Mã vai trò không được vượt quá 100 ký tự.',
    'staff.role.validation.nameRequired': 'Vui lòng nhập tên vai trò.',
    'staff.role.validation.nameMax': 'Tên vai trò không được vượt quá 255 ký tự.',
    'staff.role.dataScope.title': 'Phạm vi dữ liệu',
    'staff.role.dataScope.hint': 'Giới hạn dữ liệu mà vai trò được phép xem và thao tác.',
    'staff.role.dataScope.all': 'Toàn bộ dữ liệu trong chi nhánh',
    'staff.role.dataScope.restricted': 'Giới hạn dữ liệu',
    'staff.role.dataScope.operator': 'Điều kiện kết hợp',
    'staff.role.dataScope.or': 'Một trong các điều kiện (OR)',
    'staff.role.dataScope.and': 'Đồng thời tất cả điều kiện (AND)',
    'staff.role.dataScope.staff': 'Nhân viên',
    'staff.role.dataScope.department': 'Phòng ban',
    'staff.role.dataScope.workShift': 'Ca làm việc',
    'staff.role.dataScope.staffCount': '{count} nhân viên',
    'staff.role.dataScope.hasInactive': 'Có mục ngừng hoạt động',
    'staff.role.scopes.global': 'Toàn hệ thống',
    'staff.role.scopes.branch': 'Theo chi nhánh',
    'staff.role.scopes.both': 'Cả hai',
    'staff.attendance.today.title': 'Chấm công hôm nay',
    'staff.attendance.online.title': 'Chấm công trực tuyến',
    'staff.attendance.online.timer': 'Giờ hiện tại',
    'staff.attendance.online.timer.completed': 'Ca đã hoàn thành',
    'staff.attendance.online.subtitle': 'Chấm công từ trình duyệt và lưu dấu thời gian, tọa độ, IP cùng thông tin thiết bị để xác minh.',
    'staff.attendance.online.open': 'Mở chấm công trực tuyến',
    'staff.attendance.online.requirement': 'Cần cấp quyền vị trí để hệ thống lấy tọa độ trước mỗi lần chấm công.',
    'staff.attendance.online.checkInSuccess': 'Đã ghi nhận chấm công vào.',
    'staff.attendance.online.checkOutSuccess': 'Đã ghi nhận chấm công ra.',
    'staff.attendance.online.breakStartSuccess': 'Đã ghi nhận ra giữa giờ.',
    'staff.attendance.online.resumeSuccess': 'Đã ghi nhận vào lại ca.',
    'staff.attendance.online.dashboard.title': 'Theo dõi chấm công trực tuyến',
    'staff.attendance.online.dashboard.subtitle': 'Theo dõi trạng thái theo ngày, phòng ban, nhân viên và ca làm việc.',
    'staff.attendance.online.detail.summary': 'Thông tin ca làm việc',
    'staff.attendance.online.detail.events': 'Các lượt xác minh',
    'staff.attendance.online.fields.department': 'Phòng ban',
    'staff.attendance.online.fields.timestamp': 'Thời gian ghi nhận',
    'staff.attendance.online.fields.source': 'Hình thức',
    'staff.attendance.online.fields.deviceType': 'Thiết bị',
    'staff.attendance.online.fields.deviceId': 'ID thiết bị',
    'staff.attendance.online.fields.ipAddress': 'Địa chỉ IP',
    'staff.attendance.online.fields.location': 'Vị trí',
    'staff.attendance.online.fields.accuracy': 'Sai số GPS',
    'staff.attendance.online.fields.distance': 'Khoảng cách',
    'staff.attendance.online.fields.networkStatus': 'Xác minh mạng',
    'staff.attendance.online.fields.geofenceStatus': 'Xác minh vị trí',
    'staff.attendance.online.fields.userAgent': 'User-Agent',
    'staff.attendance.online.fields.verificationMethod': 'Cách xác minh',
    'staff.attendance.online.fields.deviceTime': 'Thời gian trên thiết bị',
    'staff.attendance.online.fields.receivedAt': 'Thời gian máy chủ nhận',
    'staff.attendance.online.fields.openMap': 'Mở bản đồ',
    'staff.attendance.online.filters.department': 'Phòng ban',
    'staff.attendance.online.filters.staff': 'Nhân viên',
    'staff.attendance.online.filters.workShift': 'Ca làm việc',
    'staff.attendance.online.source.standard': 'Chấm công thường',
    'staff.attendance.online.source.onlineWeb': 'Chấm công trực tuyến',
    'staff.attendance.online.source.faceDevice': 'Máy chấm công',
    'staff.attendance.online.device.unknown': 'Không xác định được thiết bị',
    'staff.attendance.online.verified': 'Đạt',
    'staff.attendance.online.failed': 'Không đạt',
    'staff.attendance.online.exception.process': 'Xem và xử lý ngoại lệ',
    'staff.attendance.today.noAssignment': 'Hiện không có ca làm việc phù hợp để chấm công.',
    'staff.attendance.today.requirements':
      'Vui lòng kết nối mạng CLB và bật quyền vị trí chính xác trước khi chấm công.',
    'staff.attendance.today.requirementsLocation':
      'Vui lòng bật quyền vị trí chính xác trước khi chấm công.',
    'staff.attendance.today.requirementsNetwork': 'Vui lòng kết nối mạng CLB trước khi chấm công.',
    'staff.attendance.actions.checkIn': 'Chấm công vào',
    'staff.attendance.actions.checkOut': 'Xác nhận hết ca',
    'staff.attendance.actions.startShift': 'Vào ca',
    'staff.attendance.actions.resumeShift': 'Vào lại ca',
    'staff.attendance.actions.leaveTemporarily': 'Ra giữa giờ',
    'staff.attendance.actions.endShift': 'Kết thúc ca',
    'staff.attendance.actions.requestLeave': 'Xin nghỉ',
    'staff.attendance.actions.completed': 'Đã hoàn tất',
    'staff.attendance.actions.unavailable': 'Chưa đến giờ chấm công',
    'staff.attendance.fields.employeeCode': 'Mã nhân viên',
    'staff.attendance.fields.staff': 'Nhân viên',
    'staff.attendance.fields.date': 'Ngày công',
    'staff.attendance.fields.shift': 'Ca làm việc',
    'staff.attendance.fields.scheduled': 'Lịch dự kiến',
    'staff.attendance.fields.checkIn': 'Giờ vào',
    'staff.attendance.fields.checkOut': 'Giờ ra',
    'staff.attendance.fields.status': 'Trạng thái',
    'staff.attendance.fields.evidence': 'Xác minh',
    'staff.attendance.evidence.detailTitle': 'Chi tiết xác minh chấm công',
    'staff.attendance.evidence.detailCount': '{count} lượt xác minh',
    'staff.attendance.evidence.empty': 'Chưa có lượt xác minh nào.',
    'staff.attendance.filters.dateRange': 'Khoảng ngày',
    'staff.attendance.filters.staffId': 'ID nhân viên',
    'staff.attendance.filters.status': 'Trạng thái',
    'staff.attendance.status.pending': 'Chưa chấm công',
    'staff.attendance.status.all': 'Tất cả',
    'staff.attendance.status.working': 'Đang làm',
    'staff.attendance.status.completed': 'Đã hoàn tất',
    'staff.attendance.status.missed': 'Thiếu chấm công',
    'staff.attendance.errors.unsupportedLocation': 'Thiết bị không hỗ trợ lấy vị trí.',
    'staff.attendance.errors.locationPermissionDenied':
      'Bạn chưa cấp quyền vị trí. Hãy cho phép trình duyệt truy cập vị trí rồi thử lại.',
    'staff.attendance.errors.locationTimeout':
      'Không lấy được vị trí trong thời gian cho phép. Hãy bật GPS, đứng ở nơi thoáng và thử lại.',
    'staff.attendance.errors.locationUnavailable':
      'Thiết bị hiện không xác định được vị trí. Hãy kiểm tra GPS và kết nối mạng.',
    'staff.attendance.errors.attendance_assignment_not_found':
      'Không tìm thấy ca làm việc phù hợp của bạn tại chi nhánh hiện tại.',
    'staff.attendance.errors.attendance_outside_time_window':
      'Hiện không nằm trong thời gian được phép chấm công cho ca này.',
    'staff.attendance.errors.attendance_already_checked_in': 'Bạn đã chấm công vào cho ca này rồi.',
    'staff.attendance.errors.attendance_already_checked_out': 'Bạn đã xác nhận hết ca này rồi.',
    'staff.attendance.errors.attendance_shift_already_ended':
      'Ca này đã được kết thúc, không thể chấm công vào lại.',
    'staff.attendance.errors.attendance_check_in_required':
      'Bạn cần chấm công vào trước khi xác nhận hết ca.',
    'staff.attendance.errors.attendance_location_required': 'Cần bật quyền vị trí để chấm công.',
    'staff.attendance.errors.attendance_location_inaccurate':
      'Vị trí GPS chưa đủ chính xác. Hãy bật chế độ vị trí chính xác và thử lại ở nơi thoáng.',
    'staff.attendance.errors.attendance_outside_geofence':
      'Bạn đang ở ngoài khu vực chấm công được cấu hình cho chi nhánh này.',
    'staff.attendance.errors.attendance_network_not_allowed':
      'Thiết bị chưa kết nối đúng mạng CLB. IP hệ thống ghi nhận là {detail}. Hãy kết nối Wi-Fi CLB rồi thử lại hoặc liên hệ quản lý để cập nhật IP/CIDR.',
    'staff.attendance.errors.attendance_branch_mismatch':
      'Ca làm việc không thuộc chi nhánh bạn đang chọn.',
    'staff.attendance.errors.attendance_settings_missing':
      'Chi nhánh chưa được cấu hình vị trí và mạng chấm công. Vui lòng liên hệ quản lý.',
    'staff.attendance.errors.attendance_range_too_large':
      'Khoảng thời gian tra cứu tối đa là 92 ngày.',
    'staff.attendance.settings.button': 'Cấu hình chấm công',
    'staff.attendance.settings.title': 'Cấu hình chấm công cho chi nhánh',
    'staff.attendance.settings.subtitle':
      'Thiết lập điều kiện mạng và vị trí áp dụng riêng cho chi nhánh hiện tại.',
    'staff.attendance.settings.securityHint':
      'Trình duyệt không đọc được tên Wi-Fi. Hệ thống xác minh mạng bằng IP/CIDR và xác minh địa điểm bằng GPS.',
    'staff.attendance.settings.latitude': 'Latitude',
    'staff.attendance.settings.longitude': 'Longitude',
    'staff.attendance.settings.latitudeHint': 'Vĩ độ của vị trí chấm công tại CLB.',
    'staff.attendance.settings.longitudeHint': 'Kinh độ của vị trí chấm công tại CLB.',
    'staff.attendance.settings.radius': 'Bán kính (m)',
    'staff.attendance.settings.accuracy': 'GPS tối đa (m)',
    'staff.attendance.settings.radiusHint':
      'Nhân viên phải nằm trong bán kính này tính từ tọa độ CLB.',
    'staff.attendance.settings.accuracyHint':
      'Từ chối nếu sai số GPS của thiết bị lớn hơn giá trị này.',
    'staff.attendance.settings.networkName': 'Tên mạng CLB',
    'staff.attendance.settings.networkCidr': 'IP/CIDR mạng CLB',
    'staff.attendance.settings.networkNameHint': 'Tên gợi nhớ để quản lý nhận biết cấu hình mạng.',
    'staff.attendance.settings.networkCidrHint':
      'Nhập IPv4 như 203.0.113.10 để cho phép cả dải 203.0.113.1–255.',
    'staff.attendance.settings.networkCidrHintWithIp':
      'IP request hiện tại: {ip}. Nhập IP này để cho phép cả dải .1–.255 cùng lớp mạng.',
    'staff.attendance.settings.observedIp': 'IP hiện tại của request',
    'staff.attendance.settings.facePunchMode': 'Cách xác định giờ vào/ra từ máy FaceID',
    'staff.attendance.settings.facePunchModeAlternating': 'Luân phiên vào – ra',
    'staff.attendance.settings.facePunchModeFirstLast': 'Lần đầu vào – các lần sau cập nhật giờ ra',
    'staff.attendance.settings.facePunchModeHint':
      'Chọn cách hệ thống diễn giải nhiều lần nhận diện khuôn mặt trong cùng một ca.',
    'staff.attendance.settings.useLocation': 'Lấy vị trí hiện tại',
    'staff.attendance.settings.requireNetwork': 'Bắt buộc đúng mạng CLB',
    'staff.attendance.settings.requireLocation': 'Bắt buộc trong bán kính GPS',
    'staff.attendance.settings.requireNetworkHint':
      'Khi bật, IP request phải thuộc IP/CIDR đã cấu hình.',
    'staff.attendance.settings.requireLocationHint':
      'Khi bật, vị trí GPS phải nằm trong bán kính cho phép.',
    'staff.attendance.settings.defaultNetworkName': 'Wi-Fi CLB',
    'staff.attendance.settings.saved': 'Đã lưu cấu hình chấm công cho chi nhánh hiện tại.',
    'staff.attendance.monthly.open': 'Lịch sử điểm danh',
    'staff.attendance.overview.title': 'Chấm công tháng và thống kê thời gian ra vào',
    'staff.attendance.overview.employeeSearch': 'Tên nhân viên',
    'staff.attendance.overview.month': 'Chọn tháng',
    'staff.attendance.overview.statusLabel': 'Trạng thái',
    'staff.attendance.overview.departmentLabel': 'Tên bộ phận',
    'staff.attendance.overview.all': 'Tất cả',
    'staff.attendance.overview.export': 'Xuất dữ liệu',
    'staff.attendance.overview.refresh': 'Làm mới',
    'staff.attendance.overview.employeeCode': 'Mã nhân viên',
    'staff.attendance.overview.employeeName': 'Tên nhân viên',
    'staff.attendance.overview.department': 'Bộ phận',
    'staff.attendance.overview.checkIn': 'Vào',
    'staff.attendance.overview.checkOut': 'Ra',
    'staff.attendance.overview.empty': 'Không có dữ liệu',
    'staff.attendance.overview.status.all': 'Tất cả',
    'staff.attendance.overview.status.unconfirmed': 'Chưa gửi xác nhận đủ',
    'staff.attendance.overview.status.adjustment_pending': 'Còn yêu cầu chỉnh công',
    'staff.attendance.overview.status.ready_to_lock': 'Đã xác nhận, sẵn sàng khóa',
    'staff.attendance.overview.status.locked': 'Đã khóa công',
    'staff.attendance.overview.status.not_required': 'Không cần xác nhận',
    'staff.attendance.overview.status.submitted': 'Đã gửi xác nhận đủ',
    'staff.attendance.overview.status.approved': 'Đã phê duyệt đủ',
    'staff.attendance.overview.status.confirmed': 'Đã xác nhận công tháng',
    'staff.attendance.overview.legend.unconfirmed': 'Chưa gửi xác nhận đủ:',
    'staff.attendance.overview.legend.adjustment_pending': 'Còn yêu cầu chỉnh công:',
    'staff.attendance.overview.legend.ready_to_lock': 'Sẵn sàng khóa:',
    'staff.attendance.overview.legend.locked': 'Đã khóa công:',
    'staff.attendance.overview.pendingShort': 'chờ chỉnh công',
    'staff.attendance.overview.unmatchedShort': 'chưa đối soát',
    'staff.attendance.overview.legend.submitted': 'Đã gửi xác nhận đủ:',
    'staff.attendance.overview.legend.approved': 'Đã phê duyệt đủ:',
    'staff.attendance.overview.legend.confirmed': 'Đã xác nhận công tháng:',
    'staff.attendance.monthly.title': 'Lịch sử điểm danh theo tháng',
    'staff.attendance.monthly.back': 'Quay lại chấm công',
    'staff.attendance.monthly.staff': 'Chọn nhân viên',
    'staff.attendance.monthly.month': 'Chọn tháng',
    'staff.attendance.monthly.months.1': 'Tháng 1',
    'staff.attendance.monthly.months.2': 'Tháng 2',
    'staff.attendance.monthly.months.3': 'Tháng 3',
    'staff.attendance.monthly.months.4': 'Tháng 4',
    'staff.attendance.monthly.months.5': 'Tháng 5',
    'staff.attendance.monthly.months.6': 'Tháng 6',
    'staff.attendance.monthly.months.7': 'Tháng 7',
    'staff.attendance.monthly.months.8': 'Tháng 8',
    'staff.attendance.monthly.months.9': 'Tháng 9',
    'staff.attendance.monthly.months.10': 'Tháng 10',
    'staff.attendance.monthly.months.11': 'Tháng 11',
    'staff.attendance.monthly.months.12': 'Tháng 12',
    'staff.attendance.monthly.print': 'In',
    'staff.attendance.monthly.exportExcel': 'Xuất Excel',
    'staff.attendance.monthly.printTitle': 'Bảng chấm công nhân viên',
    'staff.attendance.monthly.printStaff': 'Nhân viên: {code} - {name}',
    'staff.attendance.monthly.printMonth': 'Tháng: {month}',
    'staff.attendance.monthly.refresh': 'Làm mới',
    'staff.attendance.monthly.selectStaff': 'Vui lòng chọn một nhân viên để xem lịch sử điểm danh.',
    'staff.attendance.monthly.detail': 'Chi tiết',
    'staff.attendance.monthly.convertUnpaid': 'Nghỉ không lương',
    'staff.attendance.monthly.unpaidLeave': 'Nghỉ không lương',
    'staff.attendance.monthly.leave': 'Nghỉ phép',
    'staff.attendance.monthly.leaveWithHours': '{name} ({hours} giờ)',
    'staff.attendance.monthly.overtimeLabel': 'Tăng ca {time}',
    'staff.attendance.monthly.unpaidLeaveNotEligible':
      'Một hoặc nhiều ngày đã có điểm danh, đã có đơn nghỉ, chưa kết thúc ca hoặc không có lịch. Vui lòng tải lại trang.',
    'staff.attendance.monthly.convertSelectedUnpaid': 'Nghỉ không lương ({count})',
    'staff.attendance.monthly.convertUnpaidConfirm':
      'Chuyển {count} ngày đã chọn thành nghỉ không lương?',
    'staff.attendance.monthly.selectAllDates': 'Chọn tất cả ngày có thể thao tác',
    'staff.attendance.monthly.selectDate': 'Chọn ngày {date}',
    'staff.attendance.monthly.detailTitle': 'Chi tiết điểm danh',
    'staff.attendance.monthly.close': 'Đóng',
    'staff.attendance.monthly.shiftLabel': 'Ca làm việc',
    'staff.attendance.monthly.statusLabel': 'Trạng thái',
    'staff.attendance.monthly.meters': 'm',
    'staff.attendance.monthly.status.pending': 'Chờ giờ vào',
    'staff.attendance.monthly.status.working': 'Đang làm việc',
    'staff.attendance.monthly.status.completed': 'Hoàn tất',
    'staff.attendance.monthly.status.missed': 'Vắng/thiếu chấm công',
    'staff.attendance.adjustment.pendingButton': 'Cần xử lý ({count})',
    'staff.attendance.adjustment.pendingTitle': 'Yêu cầu chỉnh sửa giờ công',
    'staff.attendance.adjustment.requestList': 'Danh sách yêu cầu',
    'staff.attendance.adjustment.empty': 'Không có yêu cầu đang chờ xử lý.',
    'staff.attendance.adjustment.selfHint':
      'Bạn có thể gửi yêu cầu điều chỉnh giờ vào/ra. Yêu cầu sẽ được duyệt trước khi cập nhật.',
    'staff.attendance.adjustment.overrideHint':
      'Bạn có quyền sửa trực tiếp giờ vào. Punch gốc vẫn được giữ để đối soát.',
    'staff.attendance.adjustment.overrideSubmit': 'Cập nhật giờ vào',
    'staff.attendance.adjustment.managerOverrideHint':
      'Bạn có thể sửa trực tiếp giờ vào và giờ ra. Lý do và lịch sử chỉnh sửa được lưu lại.',
    'staff.attendance.adjustment.managerOverrideSubmit': 'Cập nhật giờ vào/ra',
    'staff.attendance.adjustment.checkInRequired': 'Vui lòng nhập giờ vào hợp lệ.',
    'staff.attendance.adjustment.reason': 'Lý do thay đổi',
    'staff.attendance.adjustment.submit': 'Gửi yêu cầu',
    'staff.attendance.adjustment.reasonRequired': 'Vui lòng nhập lý do thay đổi.',
    'staff.attendance.adjustment.timeRequired': 'Vui lòng nhập ít nhất một mốc thời gian.',
    'staff.attendance.adjustment.invalidRange': 'Giờ ra không được nhỏ hơn giờ vào.',
    'staff.attendance.adjustment.noChange': 'Chưa có thay đổi để gửi yêu cầu.',
    'staff.attendance.adjustment.submitted': 'Đã gửi yêu cầu và đang chờ duyệt.',
    'staff.attendance.adjustment.approve': 'Duyệt',
    'staff.attendance.adjustment.reject': 'Từ chối',
    'staff.attendance.adjustment.approveHint': 'để áp dụng thay đổi',
    'staff.attendance.adjustment.rejectHint': 'để giữ nguyên giờ công ban đầu.',
    'staff.attendance.adjustment.rejectTitle': 'Từ chối yêu cầu',
    'staff.attendance.adjustment.rejectReason': 'Lý do từ chối',
    'staff.attendance.adjustment.sentRequest': 'Yêu cầu đã gửi',
    'staff.attendance.adjustment.status.pending': 'Đang chờ duyệt',
    'staff.attendance.adjustment.status.approved': 'Đã duyệt',
    'staff.attendance.adjustment.status.rejected': 'Đã từ chối',
    'staff.attendance.adjustment.rejectionReason': 'Lý do từ chối',
    'staff.attendance.adjustment.sendAgain': 'Gửi lại yêu cầu',
    'staff.attendance.adjustment.edit': 'Chỉnh sửa',
    'staff.attendance.adjustment.cancel': 'Hủy yêu cầu',
    'staff.attendance.adjustment.status.cancelled': 'Đã hủy',
    'staff.attendance.history.title': 'Lịch sử thay đổi',
    'staff.attendance.history.updatedBy': 'Người cập nhật',
    'staff.attendance.history.empty': 'Chưa có lịch sử thay đổi.',
    'staff.attendance.history.managerDirect': 'Quản lý cập nhật trực tiếp',
    'staff.attendance.history.manager': 'Quản lý',
    'staff.attendance.history.approvedBy': 'Duyệt bởi',
    'staff.attendance.history.rejectedBy': 'Từ chối bởi',
    'staff.attendance.history.requestedBy': 'Người yêu cầu',
    'staff.attendance.history.changeTime': 'Thời gian thay đổi',
    'staff.attendance.errors.attendance_adjustment_self_only':
      'Bạn chỉ có thể yêu cầu điều chỉnh chấm công của chính mình.',
    'staff.attendance.errors.attendance_adjustment_no_change':
      'Thời gian chấm công chưa có thay đổi.',
    'staff.attendance.errors.attendance_adjustment_already_pending':
      'Yêu cầu điều chỉnh đã được gửi và đang chờ duyệt.',
    'staff.attendance.errors.attendance_adjustment_already_processed':
      'Yêu cầu điều chỉnh này đã được xử lý.',
    'staff.attendance.monthly.unknownShift': 'Ca không xác định',
    'staff.attendance.monthly.unsupported': 'Chưa hỗ trợ',
    'staff.attendance.monthly.columns.date': 'Ngày',
    'staff.attendance.monthly.columns.weekday': 'Thứ',
    'staff.attendance.monthly.columns.type': 'Lịch làm việc',
    'staff.attendance.monthly.columns.worked': 'Giờ làm',
    'staff.attendance.monthly.columns.overtime': 'Tăng ca',
    'staff.attendance.monthly.columns.note': 'Ghi chú',
    'staff.attendance.monthly.columns.action': 'Hành động',
    'staff.attendance.monthly.dayType.future': 'Ngày tương lai',
    'staff.attendance.monthly.dayType.missing_check_in': 'Thiếu giờ vào',
    'staff.attendance.monthly.dayType.missing_check_out': 'Thiếu giờ ra',
    'staff.attendance.monthly.dayType.working': 'Làm việc',
    'staff.attendance.monthly.dayType.scheduled': 'Có lịch',
    'staff.attendance.monthly.dayType.no_schedule': 'Không có lịch',
    'staff.attendance.monthly.weekday.1': 'Thứ 2',
    'staff.attendance.monthly.weekday.2': 'Thứ 3',
    'staff.attendance.monthly.weekday.3': 'Thứ 4',
    'staff.attendance.monthly.weekday.4': 'Thứ 5',
    'staff.attendance.monthly.weekday.5': 'Thứ 6',
    'staff.attendance.monthly.weekday.6': 'Thứ 7',
    'staff.attendance.monthly.weekday.7': 'Chủ nhật',
    'staff.attendance.monthly.summary.schedule': 'Lịch trong tháng',
    'staff.attendance.monthly.summary.result': 'Kết quả làm việc',
    'staff.attendance.monthly.summary.time': 'Thời gian',
    'staff.attendance.monthly.metrics.scheduled_days': 'Ngày có lịch',
    'staff.attendance.monthly.metrics.no_schedule_days': 'Ngày không có lịch',
    'staff.attendance.monthly.metrics.holiday_days': 'Ngày lễ',
    'staff.attendance.monthly.metrics.attendance_days': 'Ngày có chấm công',
    'staff.attendance.monthly.metrics.complete_days': 'Ngày đủ công',
    'staff.attendance.monthly.metrics.actual_work_days': 'Số công thực tế',
    'staff.attendance.monthly.metrics.missing_check_in_days': 'Ngày thiếu giờ vào',
    'staff.attendance.monthly.metrics.missing_check_out_days': 'Ngày thiếu giờ ra',
    'staff.attendance.monthly.metrics.worked_minutes': 'Tổng giờ đã làm',
    'staff.attendance.monthly.metrics.overtime_minutes': 'Tổng giờ tăng ca',
    'staff.attendance.monthly.metrics.late_minutes': 'Tổng giờ đi trễ',
    'staff.attendance.monthly.metrics.early_leave_minutes': 'Tổng giờ về sớm',
    'staff.attendance.monthly.metrics.missing_minutes': 'Tổng giờ thiếu',
    'staff.attendance.monthly.punch.type': 'Loại',
    'staff.attendance.monthly.punch.time': 'Thời gian',
    'staff.attendance.monthly.punch.accuracy': 'Sai số GPS',
    'staff.attendance.monthly.punch.distance': 'Khoảng cách',
    'staff.attendance.monthly.punch.network': 'Mạng hợp lệ',
    'staff.attendance.monthly.punch.location': 'Vị trí hợp lệ',
  },
  en: {
    'staff.actions.previousYear': 'Previous year',
    'staff.actions.nextYear': 'Next year',
    'staff.actions.more': 'Actions',
    'staff.import.clearFile': 'Remove selected file',
    'staff.role.permission.groups.face_profile': 'Attendance face profile',
    'staff.role.permission.groups.contract': 'Labor contracts',
    'staff.role.permission.groups.contract_type': 'Contract types',
    'staff.role.permission.resources.staff_contract': 'labor contracts',
    'staff.role.permission.actions.send': 'Send for approval',
    'staff.role.permission.actions.sign': 'Sign',
    'staff.role.permission.actions.renew': 'Renew',
    'staff.role.permission.actions.terminate': 'Terminate',
    'staff.role.permission.codes.staff_contract.view': 'View labor contracts',
    'staff.role.permission.codes.staff_contract.view_self': 'View own labor contracts',
    'staff.role.permission.codes.staff_contract.create': 'Create labor contracts',
    'staff.role.permission.codes.staff_contract.update': 'Update labor contracts',
    'staff.role.permission.codes.staff_contract.delete': 'Cancel labor contracts',
    'staff.role.permission.codes.staff_contract.send': 'Send labor contracts for approval',
    'staff.role.permission.codes.staff_contract.approve': 'Approve labor contracts',
    'staff.role.permission.codes.staff_contract.reject': 'Reject labor contracts',
    'staff.role.permission.codes.staff_contract.sign': 'Sign labor contracts',
    'staff.role.permission.codes.staff_contract.renew': 'Renew labor contracts',
    'staff.role.permission.codes.staff_contract.terminate': 'Terminate labor contracts',
    'staff.role.permission.codes.staff_contract.type_view': 'View contract types',
    'staff.role.permission.codes.staff_contract.type_create': 'Create contract types',
    'staff.role.permission.codes.staff_contract.type_update': 'Update contract types',
    'staff.role.permission.codes.staff_contract.type_delete': 'Delete contract types',
    'staff.role.permission.groups.payroll': 'Payroll',
    'staff.role.permission.groups.leave': 'Leave',
    'staff.role.permission.groups.overtime': 'Overtime',
    'staff.role.permission.groups.allowance': 'Allowance',
    'staff.role.permission.groups.salary_advance': 'Salary advance',
    'staff.role.permission.groups.insurance': 'Insurance',
    'staff.role.permission.groups.attendance_device': 'Attendance device',
    'staff.fields.department': 'Department',
    'staff.department.quickCreate': 'Quick add department',
    'staff.department.name': 'Department name',
    'staff.department.description': 'Description',
    'staff.department.create': 'Add department',
    'staff.department.update': 'Update department',
    'staff.department.code': 'Department code',
    'staff.department.staffCount': 'Total staff',
    'staff.department.activeStaff': 'Active staff',
    'staff.department.status': 'Status',
    'staff.department.sortOrder': 'Sort order',
    'staff.department.search': 'Search by code or name',
    'staff.department.sortOrderInteger': 'Sort order must be an integer',
    'staff.department.deleteConfirm': 'Delete department {name}?',
    'staff.department.mobileStaffCount': 'Total: {count} staff',
    'staff.department.mobileActiveStaff': 'Active: {count}',
    'staff.department.errors.hasStaff':
      'This department cannot be deleted because it has {count} assigned staff members. Move them to another department before deleting it.',
    'staff.department.notifications.createFailed': 'Failed to add department.',
    'staff.department.notifications.updateFailed': 'Failed to update department.',
    'staff.department.notifications.deleteFailed': 'Failed to delete department.',
    'staff.model': 'Staff',
    'staff.title': 'Staff management',
    'staff.sections.login': 'Login information',
    'staff.sections.profile': 'Personal information',
    'staff.sections.face': 'AI06 attendance face',
    'staff.sections.salary': 'Salary settings',
    'staff.sections.allowances': 'Assigned allowances',
    'staff.tabs.profile': 'Employee information',
    'staff.tabs.compensation': 'Salary settings',
    'staff.nav.label': 'Employee information groups',
    'staff.nav.general': 'General',
    'staff.nav.hrProfile': 'HR profile',
    'staff.nav.finance': 'Finance',
    'staff.nav.documents': 'Documents',
    'staff.sections.globalRoles': 'Global roles',
    'staff.sections.branchAssignments': 'Branch assignments',
    'staff.sections.faceDevices': 'FaceID device synchronization',
    'staff.fields.employeeCode': 'Employee code',
    'staff.fields.fullName': 'Full name',
    'staff.fields.username': 'Username',
    'staff.fields.password': 'Password',
    'staff.fields.phone': 'Phone',
    'staff.fields.email': 'Email',
    'staff.fields.avatar': 'Avatar',
    'staff.fields.faceImage': 'Face recognition image',
    'staff.fields.gender': 'Gender',
    'staff.fields.birthday': 'Birthday',
    'staff.fields.address': 'Address',
    'staff.fields.salaryType': 'Salary type',
    'staff.fields.salaryAmount': 'Salary amount',
    'staff.fields.socialInsuranceBase': 'Social insurance contribution base',
    'staff.salary.socialInsuranceHint':
      'Insurance contribution base. Leave 0 when not applicable; the payslip deducts 8% social insurance and the selected items below.',
    'staff.salary.healthInsuranceOption': 'Health insurance (employee 1.5%)',
    'staff.salary.unemploymentInsuranceOption': 'Unemployment insurance (employee 1%)',
    'staff.salary.types.fixed': 'Fixed monthly salary',
    'staff.salary.types.daily': 'Daily salary',
    'staff.salary.types.hourly': 'Hourly salary',
    'staff.salary.amountLabels.fixed': 'Monthly salary',
    'staff.salary.amountLabels.daily': 'Daily salary amount',
    'staff.salary.amountLabels.hourly': 'Hourly salary amount',
    'staff.validation.salaryAmountPositive': 'Salary amount must be greater than 0.',
    'staff.allowances.empty': 'No allowance type is assigned to this employee.',
    'staff.allowances.type': 'Allowance type',
    'staff.allowances.amountOverride': 'Custom amount (blank uses default)',
    'staff.allowances.startsOn': 'Effective from',
    'staff.allowances.endsOn': 'Effective to',
    'staff.allowances.note': 'Note',
    'staff.allowances.remove': 'Remove allowance',
    'staff.allowances.conditionSummary': 'Calculation condition: {basis}',
    'staff.allowances.basis.fixed_monthly': 'Fixed monthly',
    'staff.allowances.basis.worked_day': 'Per attended workday',
    'staff.allowances.basis.completed_shift': 'Per completed shift',
    'staff.allowances.basis.worked_hour': 'Per actual worked hour',
    'staff.fields.status': 'Status',
    'staff.fields.globalRoles': 'Global roles',
    'staff.fields.branches': 'Branches',
    'staff.fields.branch': 'Branch',
    'staff.fields.branchRole': 'Branch role',
    'staff.fields.defaultBranch': 'Default branch',
    'staff.fields.faceDeviceSyncMode': 'FaceID sync scope',
    'staff.fields.faceDevices': 'Allowed devices',
    'staff.fields.faceCaptureDevices': 'Devices requiring a new face capture',
    'staff.faceDevices.all': 'All devices in assigned branches',
    'staff.faceDevices.selected': 'Selected devices only',
    'staff.faceDevices.allHint':
      'The staff member will automatically sync to every active device in their assigned branches.',
    'staff.faceDevices.captureHint':
      'After saving, each selected device will ask the staff member to stand in front of it for a new face capture.',
    'staff.fields.assignmentCount': 'Branches',
    'staff.fields.lastLogin': 'Last login',
    'staff.fields.mustChangePassword': 'Require password change on first login',
    'staff.actions.add': 'Add staff',
    'staff.actions.create': 'Add staff',
    'staff.actions.update': 'Edit staff',
    'staff.actions.submitCreate': 'Add staff',
    'staff.actions.submitUpdate': 'Edit staff',
    'staff.actions.cancel': 'Cancel',
    'staff.actions.delete': 'Delete',
    'staff.actions.deactivate': 'Set inactive',
    'staff.actions.restore': 'Restore',
    'staff.actions.resetPassword': 'Reset password',
    'staff.actions.confirmPassword': 'Confirm password',
    'staff.actions.generatePassword': 'Generate password',
    'staff.actions.import': 'Import Excel',
    'staff.actions.export': 'Export Excel',
    'staff.actions.deleteTitle': 'Delete staff',
    'staff.dialog.createSubtitle': 'Enter staff information to add them to the system',
    'staff.dialog.updateSubtitle': 'Update staff information',
    'staff.import.title': 'Import staff list',
    'staff.import.subtitle': 'Download the template, enter data, and validate it before importing',
    'staff.import.loadingCatalog': 'Loading department, branch, and role catalogs...',
    'staff.import.templateTitle': 'Download the Excel template',
    'staff.import.templateDescription':
      'The template includes all data columns, instructions, and codes currently used by the system.',
    'staff.import.downloadTemplate': 'Download template',
    'staff.import.requiredLegend': 'Required field.',
    'staff.import.conditionalLegend':
      'Required unless the staff member has the OWNER or SUPER_ADMIN role.',
    'staff.import.notes.password': 'Passwords must contain at least 6 characters.',
    'staff.import.notes.unique': 'Username, employee code, email, and phone number must be unique.',
    'staff.import.notes.values':
      'Use YYYY-MM-DD for birthdays, male/female for gender, and active/inactive/locked for status.',
    'staff.import.notes.department':
      'Department code is required and must be selected from the Catalog sheet in the template.',
    'staff.import.notes.assignment':
      'Use BRANCH_CODE|ROLE_CODE for assignments and semicolons for multiple branches.',
    'staff.import.notes.security':
      'The file contains initial passwords and is sensitive; protect and delete it after use.',
    'staff.import.notes.avatar': 'Add staff avatars after the import is complete.',
    'staff.import.fileTitle': 'Choose a file to import',
    'staff.import.fileDescription': 'Each row is validated and only valid rows will be processed.',
    'staff.import.chooseFile': 'Choose Excel file',
    'staff.import.supportedFormats': 'Supports .xlsx and .xls; maximum 5 MB',
    'staff.import.summary.total': 'Total: {count}',
    'staff.import.summary.valid': 'Valid: {count}',
    'staff.import.summary.invalid': 'Errors: {count}',
    'staff.import.errorListTitle': 'Rows that need attention',
    'staff.import.rowLabel': 'Row {row}',
    'staff.import.process': 'Import {count} staff',
    'staff.import.result': '{success} staff imported successfully; {failed} rows failed.',
    'staff.import.errors.invalidFileType': 'Only .xlsx or .xls Excel files are supported.',
    'staff.import.errors.fileTooLarge': 'The file must not exceed 5 MB.',
    'staff.import.errors.noRows': 'The file contains no staff data rows.',
    'staff.import.errors.cannotRead':
      'The file could not be read. Use the provided template without changing column names.',
    'staff.import.errors.templateDownloadFailed':
      'Unable to download the template from the server. Please try again.',
    'staff.import.errors.rowFailed': 'Unable to add this staff member.',
    'staff.export.error': 'Unable to export the staff list. Please try again.',
    'staff.dialog.avatarHint':
      'JPG, PNG, or WebP (up to 5MB). This image is also used for FaceID recognition.',
    'staff.dialog.faceHint': 'JPG or PNG, up to 10MB',
    'staff.dialog.faceDescription':
      "The image is stored privately and automatically queued for synchronization to the tenant's FaceID device.",
    'staff.deleteConfirm': 'Are you sure you want to delete staff member {name}?',
    'staff.deleteHint': 'Staff with existing system activity can only be set to Inactive.',
    'staff.status.active': 'Active',
    'staff.status.inactive': 'Inactive',
    'staff.status.locked': 'Locked',
    'staff.gender.male': 'Male',
    'staff.gender.female': 'Female',
    'staff.gender.other': 'Other',
    'staff.validation.birthdayMinAge': 'Staff must be older than {age}',
    'staff.validation.birthdayMinAgeOrEqual':
      'Staff must be greater than or equal to {age} years old',
    'staff.validation.birthdayFuture': 'Birthday cannot be in the future',
    'staff.validation.branchRequired':
      'Staff without a full-access global role must be assigned to at least one branch',
    'staff.validation.branchRoleRequired': 'Please select a role for every selected branch',
    'staff.validation.defaultBranchRequired': 'Please select one default branch',
    'staff.placeholders.autoCode': 'Generated automatically when blank',
    'staff.errors.saveFailed': 'Unable to save staff. Please try again.',
    'staff.errors.avatarUploadFailed': 'Unable to upload avatar. Please try again.',
    'staff.errors.faceUploadFailed': 'Unable to upload the face image. Please try again.',
    'staff.errors.faceImageInvalid': 'The face image must be JPG or PNG and no larger than 10MB.',
    'staff.errors.roleLoadFailed': 'Unable to load roles.',
    'staff.role.title': 'Roles and permissions',
    'staff.role.fields.code': 'Role code',
    'staff.role.fields.name': 'Role name',
    'staff.role.fields.scope': 'Scope',
    'staff.role.fields.status': 'Status',
    'staff.role.fields.permissions': 'Permissions',
    'staff.role.fields.staffCount': 'Staff',
    'staff.filters.role': 'Role',
    'staff.filters.branch': 'Branch',
    'staff.role.filters.search': 'Search roles',
    'staff.role.actions.permissions': 'Permissions',
    'staff.role.actions.savePermissions': 'Save permissions',
    'staff.role.permissionsDialog.title': 'Select permissions for role',
    'staff.role.permissionsDialog.searchLabel': 'Search permissions',
    'staff.role.permissionsDialog.searchPlaceholder': 'Enter a permission name or code',
    'staff.role.permissionsDialog.moduleLabel': 'Feature group',
    'staff.role.permissionsDialog.allModules': 'All feature groups',
    'staff.role.permissionsDialog.selected': 'permissions selected',
    'staff.role.permissionsDialog.resultCount': 'Showing {count} matching permissions',
    'staff.role.permissionsDialog.relatedPermission': 'Related permission',
    'staff.role.permissionsDialog.relatedTitle': 'Related permissions',
    'staff.role.permissionsDialog.relatedHint':
      'Permissions from other groups required to fully use features in the selected section.',
    'staff.role.permissionsDialog.presets.title': 'System-recommended permission templates',
    'staff.role.permissionsDialog.presets.hint':
      'Choose a job template to quickly select an appropriate permission set.',
    'staff.role.permissionsDialog.presets.editable': 'Customizable after applying',
    'staff.role.permissionsDialog.presets.apply': 'Apply permission template',
    'staff.role.permissionsDialog.presets.replaceWarning':
      'Applying replaces the currently selected permissions. Changes are only persisted after you save.',
    'staff.role.permissionsDialog.presets.permissionCount': '{count} permissions',
    'staff.role.permissionsDialog.presets.salesStaff.title': 'Sales employee',
    'staff.role.permissionsDialog.presets.salesStaff.description':
      'Sales/POS, orders, customers, payments, shift closing, and personal attendance.',
    'staff.role.permissionsDialog.presets.hrManager.title': 'HR manager',
    'staff.role.permissionsDialog.presets.hrManager.description':
      'Staff, departments, work shifts, schedules, attendance, and roles.',
    'staff.role.permissionsDialog.emptyTitle': 'No permissions found',
    'staff.role.permissionsDialog.emptyHint': 'Try another keyword or feature group.',
    'staff.role.permission.namePattern': '{action} {resource}',
    'staff.role.permission.fullAccess': 'Full system access',
    'staff.role.permission.resources.brand': 'brand',
    'staff.role.permission.resources.category': 'product category',
    'staff.role.permission.resources.location': 'location',
    'staff.role.permission.resources.unit': 'unit',
    'staff.role.permission.resources.sale_return': 'sale returns',
    'staff.role.permission.modules.system': 'System',
    'staff.role.permission.modules.dashboard': 'Dashboard',
    'staff.role.permission.modules.report': 'Reports',
    'staff.role.permission.modules.pos': 'POS sales',
    'staff.role.permission.modules.sale': 'Sales',
    'staff.role.permission.modules.sales_invoice': 'Sales invoices',
    'staff.role.permission.modules.sale_return': 'Sale returns',
    'staff.role.permission.modules.sales_order': 'Sales orders',
    'staff.role.permission.modules.sales_channel': 'Sales channels',
    'staff.role.permission.modules.sales_area': 'Sales areas',
    'staff.role.permission.modules.sales_table': 'Sales tables',
    'staff.role.permission.modules.branch': 'Branches',
    'staff.role.permission.modules.setting': 'Settings',
    'staff.role.permission.modules.delivery_partner': 'Delivery partners',
    'staff.role.permission.modules.cash_book': 'Cash book',
    'staff.role.permission.modules.bill': 'Bills',
    'staff.role.permission.modules.product': 'Products',
    'staff.role.permission.modules.price_list': 'Price lists',
    'staff.role.permission.modules.promotion': 'Promotions',
    'staff.role.permission.modules.area_pricing': 'Area pricing',
    'staff.role.permission.modules.table_pricing': 'Table pricing',
    'staff.role.permission.modules.table_session': 'Table sessions',
    'staff.role.permission.modules.booking': 'Bookings',
    'staff.role.permission.modules.inventory': 'Inventory',
    'staff.role.permission.modules.supplier': 'Suppliers',
    'staff.role.permission.modules.customer': 'Customers',
    'staff.role.permission.modules.staff': 'Staff',
    'staff.role.permission.groups.all': 'All',
    'staff.role.permission.groups.dashboard': 'Dashboard',
    'staff.role.permission.groups.shift_revenue': 'Shift revenue',
    'staff.role.permission.groups.shift_closing': 'Shift closing',
    'staff.role.permission.groups.pos': 'POS',
    'staff.role.permission.groups.kitchen': 'Kitchen',
    'staff.role.permission.groups.sale': 'Sale',
    'staff.role.permission.groups.invoice': 'Invoice',
    'staff.role.permission.groups.sale_return': 'Sale return',
    'staff.role.permission.groups.order': 'Order',
    'staff.role.permission.groups.channel': 'Channel',
    'staff.role.permission.groups.channel_products': 'Channel products',
    'staff.role.permission.groups.online_sales': 'Online sales',
    'staff.role.permission.groups.area': 'Area',
    'staff.role.permission.groups.table': 'Table',
    'staff.role.permission.groups.branch': 'Branch',
    'staff.role.permission.groups.setting': 'General settings',
    'staff.role.permission.groups.system': 'System settings',
    'staff.role.permission.groups.activity_log': 'System history',
    'staff.role.permission.groups.print_templates': 'Print templates',
    'staff.role.permission.groups.payment_methods': 'Payment methods',
    'staff.role.permission.groups.delivery_partner': 'Delivery partners',
    'staff.role.permission.groups.cash_book': 'Cash book',
    'staff.role.permission.groups.cash_transaction': 'Cash in / out',
    'staff.role.permission.groups.transaction_type': 'Transaction types',
    'staff.role.permission.groups.bill': 'Bill',
    'staff.role.permission.groups.product': 'Product',
    'staff.role.permission.groups.product_catalog': 'Product catalog',
    'staff.role.permission.groups.pricing': 'Pricing',
    'staff.role.permission.groups.voucher': 'Vouchers',
    'staff.role.permission.groups.area_pricing': 'Area pricing',
    'staff.role.permission.groups.table_pricing': 'Table pricing',
    'staff.role.permission.groups.table_session': 'Table sessions',
    'staff.role.permission.groups.booking': 'Bookings',
    'staff.role.permission.groups.inventory': 'Inventory',
    'staff.role.permission.groups.stock': 'Stock',
    'staff.role.permission.groups.inventory_check': 'Inventory checks',
    'staff.role.permission.groups.opening_stock': 'Opening stock',
    'staff.role.permission.groups.purchase_receipt': 'Purchase receipts',
    'staff.role.permission.groups.purchase_return': 'Purchase returns',
    'staff.role.permission.groups.stock_transfer': 'Stock transfers',
    'staff.role.permission.groups.supplier': 'Supplier',
    'staff.role.permission.groups.debt': 'Debt',
    'staff.role.permission.groups.payment': 'Payments',
    'staff.role.permission.groups.customer': 'Customer',
    'staff.role.permission.groups.group': 'Customer groups',
    'staff.role.permission.groups.tier': 'Membership tiers',
    'staff.role.permission.groups.receipt': 'Receipts',
    'staff.role.permission.groups.loyalty': 'Loyalty',
    'staff.role.permission.groups.staff': 'Staff',
    'staff.role.permission.groups.department': 'Department',
    'staff.role.permission.groups.work_shift': 'Work shifts',
    'staff.role.permission.groups.schedule': 'Scheduling',
    'staff.role.permission.groups.attendance': 'Attendance',
    'staff.role.permission.groups.role': 'Roles',
    'staff.role.permission.groups.permission': 'Permissions',
    'staff.role.form.createTitle': 'Add role',
    'staff.role.form.editTitle': 'Edit role',
    'staff.role.fields.description': 'Description',
    'staff.role.status.active': 'Active',
    'staff.role.status.inactive': 'Inactive',
    'staff.role.placeholders.code': 'Example: STORE_MANAGER',
    'staff.role.placeholders.name': 'Enter role name',
    'staff.role.actions.create': 'Add role',
    'staff.role.actions.update': 'Save changes',
    'staff.role.deleteDialog.title': 'Confirm role deletion',
    'staff.role.deleteDialog.message':
      'You are deleting the “{name}” role. This action cannot be undone.',
    'staff.role.deleteDialog.inUse':
      'This role cannot be deleted because it is assigned to staff. Remove it from all staff and branches before deleting it.',
    'staff.role.deleteDialog.reason': 'Deletion reason',
    'staff.role.deleteDialog.reasonPlaceholder': 'Enter the reason for deleting this role',
    'staff.role.deleteDialog.reasonHint': 'Required, between 3 and 500 characters.',
    'staff.role.validation.codeRequired': 'Role code is required.',
    'staff.role.validation.codeMax': 'Role code must not exceed 100 characters.',
    'staff.role.validation.nameRequired': 'Role name is required.',
    'staff.role.validation.nameMax': 'Role name must not exceed 255 characters.',
    'staff.role.dataScope.title': 'Data scope',
    'staff.role.dataScope.hint': 'Limit the data this role can view and manage.',
    'staff.role.dataScope.all': 'All data in the branch',
    'staff.role.dataScope.restricted': 'Restricted data',
    'staff.role.dataScope.operator': 'Combination operator',
    'staff.role.dataScope.or': 'Any condition (OR)',
    'staff.role.dataScope.and': 'All conditions (AND)',
    'staff.role.dataScope.staff': 'Staff',
    'staff.role.dataScope.department': 'Department',
    'staff.role.dataScope.workShift': 'Work shift',
    'staff.role.dataScope.staffCount': '{count} staff',
    'staff.role.dataScope.hasInactive': 'Contains inactive items',
    'staff.role.scopes.global': 'Global',
    'staff.role.scopes.branch': 'Branch',
    'staff.role.scopes.both': 'Both',
    'staff.attendance.today.title': 'Today attendance',
    'staff.attendance.online.title': 'Online attendance',
    'staff.attendance.online.timer': 'Current time',
    'staff.attendance.online.timer.completed': 'Completed shift',
    'staff.attendance.online.subtitle': 'Punch from a browser and retain the timestamp, coordinates, IP address, and device details for verification.',
    'staff.attendance.online.open': 'Open online attendance',
    'staff.attendance.online.requirement': 'Allow location access so the browser can provide coordinates before each punch.',
    'staff.attendance.online.checkInSuccess': 'Check-in recorded.',
    'staff.attendance.online.checkOutSuccess': 'Check-out recorded.',
    'staff.attendance.online.breakStartSuccess': 'Temporary exit recorded.',
    'staff.attendance.online.resumeSuccess': 'Return to shift recorded.',
    'staff.attendance.online.dashboard.title': 'Online attendance tracking',
    'staff.attendance.online.dashboard.subtitle': 'Track attendance by date, department, employee, and work shift.',
    'staff.attendance.online.detail.summary': 'Shift information',
    'staff.attendance.online.detail.events': 'Verification events',
    'staff.attendance.online.fields.department': 'Department',
    'staff.attendance.online.fields.timestamp': 'Recorded at',
    'staff.attendance.online.fields.source': 'Method',
    'staff.attendance.online.fields.deviceType': 'Device',
    'staff.attendance.online.fields.deviceId': 'Device ID',
    'staff.attendance.online.fields.ipAddress': 'IP address',
    'staff.attendance.online.fields.location': 'Location',
    'staff.attendance.online.fields.accuracy': 'GPS accuracy',
    'staff.attendance.online.fields.distance': 'Distance',
    'staff.attendance.online.fields.networkStatus': 'Network verification',
    'staff.attendance.online.fields.geofenceStatus': 'Location verification',
    'staff.attendance.online.fields.userAgent': 'User-Agent',
    'staff.attendance.online.fields.verificationMethod': 'Verification method',
    'staff.attendance.online.fields.deviceTime': 'Device time',
    'staff.attendance.online.fields.receivedAt': 'Received by server',
    'staff.attendance.online.fields.openMap': 'Open map',
    'staff.attendance.online.filters.department': 'Department',
    'staff.attendance.online.filters.staff': 'Employee',
    'staff.attendance.online.filters.workShift': 'Work shift',
    'staff.attendance.online.source.standard': 'Standard attendance',
    'staff.attendance.online.source.onlineWeb': 'Online attendance',
    'staff.attendance.online.source.faceDevice': 'Attendance device',
    'staff.attendance.online.device.unknown': 'Device could not be identified',
    'staff.attendance.online.verified': 'Passed',
    'staff.attendance.online.failed': 'Failed',
    'staff.attendance.online.exception.process': 'Review and process exception',
    'staff.attendance.today.noAssignment': 'There is no eligible shift to punch at this time.',
    'staff.attendance.today.requirements':
      'Connect to the club network and enable precise location before punching.',
    'staff.attendance.today.requirementsLocation': 'Enable precise location before punching.',
    'staff.attendance.today.requirementsNetwork': 'Connect to the club network before punching.',
    'staff.attendance.actions.checkIn': 'Check in',
    'staff.attendance.actions.checkOut': 'Confirm check-out',
    'staff.attendance.actions.startShift': 'Start shift',
    'staff.attendance.actions.resumeShift': 'Resume shift',
    'staff.attendance.actions.leaveTemporarily': 'Leave temporarily',
    'staff.attendance.actions.endShift': 'End shift',
    'staff.attendance.actions.requestLeave': 'Request leave',
    'staff.attendance.actions.completed': 'Completed',
    'staff.attendance.actions.unavailable': 'Not available yet',
    'staff.attendance.fields.employeeCode': 'Employee code',
    'staff.attendance.fields.staff': 'Staff',
    'staff.attendance.fields.date': 'Business date',
    'staff.attendance.fields.shift': 'Shift',
    'staff.attendance.fields.scheduled': 'Scheduled time',
    'staff.attendance.fields.checkIn': 'Check-in',
    'staff.attendance.fields.checkOut': 'Check-out',
    'staff.attendance.fields.status': 'Status',
    'staff.attendance.fields.evidence': 'Verification',
    'staff.attendance.evidence.detailTitle': 'Attendance verification details',
    'staff.attendance.evidence.detailCount': '{count} verification records',
    'staff.attendance.evidence.empty': 'No verification records yet.',
    'staff.attendance.filters.dateRange': 'Date range',
    'staff.attendance.filters.staffId': 'Staff ID',
    'staff.attendance.filters.status': 'Status',
    'staff.attendance.status.pending': 'Pending',
    'staff.attendance.status.all': 'All',
    'staff.attendance.status.working': 'Working',
    'staff.attendance.status.completed': 'Completed',
    'staff.attendance.status.missed': 'Missing punch',
    'staff.attendance.errors.unsupportedLocation': 'This device does not support location access.',
    'staff.attendance.errors.locationPermissionDenied':
      'Location permission is disabled. Allow browser location access and try again.',
    'staff.attendance.errors.locationTimeout':
      'Location could not be obtained in time. Enable GPS, move to an open area, and try again.',
    'staff.attendance.errors.locationUnavailable':
      'The device cannot determine its location. Check GPS and network connectivity.',
    'staff.attendance.errors.attendance_assignment_not_found':
      'No eligible assigned shift was found for you at the current branch.',
    'staff.attendance.errors.attendance_outside_time_window':
      'This action is outside the allowed attendance window for the shift.',
    'staff.attendance.errors.attendance_already_checked_in':
      'You have already checked in for this shift.',
    'staff.attendance.errors.attendance_already_checked_out':
      'You have already checked out for this shift.',
    'staff.attendance.errors.attendance_shift_already_ended':
      'This shift has ended and cannot be resumed.',
    'staff.attendance.errors.attendance_check_in_required':
      'You must check in before confirming check-out.',
    'staff.attendance.errors.attendance_location_required':
      'Location access is required to record attendance.',
    'staff.attendance.errors.attendance_location_inaccurate':
      'GPS accuracy is insufficient. Enable precise location and try again in an open area.',
    'staff.attendance.errors.attendance_outside_geofence':
      'You are outside the attendance area configured for this branch.',
    'staff.attendance.errors.attendance_network_not_allowed':
      'The device is not connected through an allowed club network. The observed IP is {detail}. Connect to club Wi-Fi or ask a manager to update the IP/CIDR.',
    'staff.attendance.errors.attendance_branch_mismatch':
      'The assigned shift does not belong to the selected branch.',
    'staff.attendance.errors.attendance_settings_missing':
      'Attendance location and network settings have not been configured for this branch. Contact a manager.',
    'staff.attendance.errors.attendance_range_too_large':
      'The history range cannot exceed 92 days.',
    'staff.attendance.settings.button': 'Attendance settings',
    'staff.attendance.settings.title': 'Branch attendance settings',
    'staff.attendance.settings.subtitle':
      'Configure network and location requirements for the current branch.',
    'staff.attendance.settings.securityHint':
      'Browsers cannot read Wi-Fi names. Network access is verified by IP/CIDR and location is verified by GPS.',
    'staff.attendance.settings.latitude': 'Latitude',
    'staff.attendance.settings.longitude': 'Longitude',
    'staff.attendance.settings.latitudeHint': 'Latitude of the club attendance point.',
    'staff.attendance.settings.longitudeHint': 'Longitude of the club attendance point.',
    'staff.attendance.settings.radius': 'Radius (m)',
    'staff.attendance.settings.accuracy': 'Max GPS accuracy (m)',
    'staff.attendance.settings.radiusHint':
      'Staff must be within this distance from the club coordinates.',
    'staff.attendance.settings.accuracyHint':
      'Reject attendance when device GPS error exceeds this value.',
    'staff.attendance.settings.networkName': 'Club network name',
    'staff.attendance.settings.networkCidr': 'Club network IP/CIDR',
    'staff.attendance.settings.networkNameHint':
      'A descriptive name for managers to identify the network.',
    'staff.attendance.settings.networkCidrHint':
      'Enter an IPv4 address such as 203.0.113.10 to allow 203.0.113.1–255.',
    'staff.attendance.settings.networkCidrHintWithIp':
      'Current request IP: {ip}. Enter it to allow the .1–.255 range in the same subnet.',
    'staff.attendance.settings.observedIp': 'Observed request IP',
    'staff.attendance.settings.facePunchMode': 'FaceID check-in/out interpretation',
    'staff.attendance.settings.facePunchModeAlternating': 'Alternate check-in and check-out',
    'staff.attendance.settings.facePunchModeFirstLast':
      'First scan checks in; later scans update check-out',
    'staff.attendance.settings.facePunchModeHint':
      'Choose how multiple face recognitions in the same shift are interpreted.',
    'staff.attendance.settings.useLocation': 'Use current location',
    'staff.attendance.settings.requireNetwork': 'Require club network',
    'staff.attendance.settings.requireLocation': 'Require GPS geofence',
    'staff.attendance.settings.requireNetworkHint':
      'When enabled, the request IP must match a configured IP/CIDR.',
    'staff.attendance.settings.requireLocationHint':
      'When enabled, GPS coordinates must be within the configured radius.',
    'staff.attendance.settings.defaultNetworkName': 'Club Wi-Fi',
    'staff.attendance.settings.saved': 'Attendance settings were saved for the current branch.',
    'staff.attendance.monthly.open': 'Attendance history',
    'staff.attendance.overview.title': 'Monthly attendance and check-in/out statistics',
    'staff.attendance.overview.employeeSearch': 'Staff name',
    'staff.attendance.overview.month': 'Month',
    'staff.attendance.overview.statusLabel': 'Status',
    'staff.attendance.overview.departmentLabel': 'Department',
    'staff.attendance.overview.all': 'All',
    'staff.attendance.overview.export': 'Export data',
    'staff.attendance.overview.refresh': 'Refresh',
    'staff.attendance.overview.employeeCode': 'Staff code',
    'staff.attendance.overview.employeeName': 'Staff name',
    'staff.attendance.overview.department': 'Department',
    'staff.attendance.overview.checkIn': 'In',
    'staff.attendance.overview.checkOut': 'Out',
    'staff.attendance.overview.empty': 'No data',
    'staff.attendance.overview.status.all': 'All',
    'staff.attendance.overview.status.unconfirmed': 'Not submitted',
    'staff.attendance.overview.status.adjustment_pending': 'Attendance adjustment pending',
    'staff.attendance.overview.status.ready_to_lock': 'Confirmed and ready to lock',
    'staff.attendance.overview.status.locked': 'Attendance locked',
    'staff.attendance.overview.status.not_required': 'Confirmation not required',
    'staff.attendance.overview.status.submitted': 'Submitted',
    'staff.attendance.overview.status.approved': 'Approved',
    'staff.attendance.overview.status.confirmed': 'Monthly attendance confirmed',
    'staff.attendance.overview.legend.unconfirmed': 'Not submitted:',
    'staff.attendance.overview.legend.adjustment_pending': 'Adjustment pending:',
    'staff.attendance.overview.legend.ready_to_lock': 'Ready to lock:',
    'staff.attendance.overview.legend.locked': 'Attendance locked:',
    'staff.attendance.overview.pendingShort': 'pending adjustments',
    'staff.attendance.overview.unmatchedShort': 'unmatched',
    'staff.attendance.overview.legend.submitted': 'Submitted:',
    'staff.attendance.overview.legend.approved': 'Approved:',
    'staff.attendance.overview.legend.confirmed': 'Monthly attendance confirmed:',
    'staff.attendance.monthly.title': 'Monthly attendance history',
    'staff.attendance.monthly.back': 'Back to attendance',
    'staff.attendance.monthly.staff': 'Select staff',
    'staff.attendance.monthly.month': 'Month',
    'staff.attendance.monthly.months.1': 'Jan',
    'staff.attendance.monthly.months.2': 'Feb',
    'staff.attendance.monthly.months.3': 'Mar',
    'staff.attendance.monthly.months.4': 'Apr',
    'staff.attendance.monthly.months.5': 'May',
    'staff.attendance.monthly.months.6': 'Jun',
    'staff.attendance.monthly.months.7': 'Jul',
    'staff.attendance.monthly.months.8': 'Aug',
    'staff.attendance.monthly.months.9': 'Sep',
    'staff.attendance.monthly.months.10': 'Oct',
    'staff.attendance.monthly.months.11': 'Nov',
    'staff.attendance.monthly.months.12': 'Dec',
    'staff.attendance.monthly.print': 'Print',
    'staff.attendance.monthly.exportExcel': 'Export Excel',
    'staff.attendance.monthly.printTitle': 'Staff attendance report',
    'staff.attendance.monthly.printStaff': 'Staff: {code} - {name}',
    'staff.attendance.monthly.printMonth': 'Month: {month}',
    'staff.attendance.monthly.refresh': 'Refresh',
    'staff.attendance.monthly.selectStaff': 'Select a staff member to view attendance history.',
    'staff.attendance.monthly.detail': 'Details',
    'staff.attendance.monthly.convertUnpaid': 'Mark as unpaid leave',
    'staff.attendance.monthly.unpaidLeave': 'Unpaid leave',
    'staff.attendance.monthly.leave': 'Leave',
    'staff.attendance.monthly.leaveWithHours': '{name} ({hours} hours)',
    'staff.attendance.monthly.overtimeLabel': 'Overtime {time}',
    'staff.attendance.monthly.unpaidLeaveNotEligible':
      'One or more days have attendance, leave, unfinished shifts, or no schedule. Please refresh the page.',
    'staff.attendance.monthly.convertSelectedUnpaid': 'Mark as unpaid leave ({count})',
    'staff.attendance.monthly.convertUnpaidConfirm': 'Mark {count} selected days as unpaid leave?',
    'staff.attendance.monthly.selectAllDates': 'Select all actionable dates',
    'staff.attendance.monthly.selectDate': 'Select {date}',
    'staff.attendance.monthly.detailTitle': 'Attendance details',
    'staff.attendance.monthly.close': 'Close',
    'staff.attendance.monthly.statusLabel': 'Status',
    'staff.attendance.monthly.meters': 'm',
    'staff.attendance.monthly.status.pending': 'Awaiting check-in',
    'staff.attendance.monthly.status.working': 'Working',
    'staff.attendance.monthly.status.completed': 'Completed',
    'staff.attendance.monthly.status.missed': 'Missed attendance',
    'staff.attendance.adjustment.pendingButton': 'Requests to process ({count})',
    'staff.attendance.adjustment.pendingTitle': 'Attendance adjustment requests',
    'staff.attendance.adjustment.requestList': 'Request list',
    'staff.attendance.adjustment.empty': 'No pending requests.',
    'staff.attendance.adjustment.selfHint':
      'You can request a check-in/check-out correction. It must be approved before attendance is updated.',
    'staff.attendance.adjustment.overrideHint':
      'You can directly override check-in time. Original punches remain available for reconciliation.',
    'staff.attendance.adjustment.overrideSubmit': 'Update check-in',
    'staff.attendance.adjustment.managerOverrideHint':
      'You can directly edit check-in and check-out. The reason and edit history are recorded.',
    'staff.attendance.adjustment.managerOverrideSubmit': 'Update check-in/out',
    'staff.attendance.adjustment.checkInRequired': 'Please enter a valid check-in time.',
    'staff.attendance.adjustment.reason': 'Change reason',
    'staff.attendance.adjustment.submit': 'Submit request',
    'staff.attendance.adjustment.reasonRequired': 'Please enter a reason.',
    'staff.attendance.adjustment.timeRequired': 'Enter at least one time.',
    'staff.attendance.adjustment.invalidRange': 'Check-out cannot be earlier than check-in.',
    'staff.attendance.adjustment.noChange': 'There are no changes to submit.',
    'staff.attendance.adjustment.submitted': 'Request submitted and awaiting approval.',
    'staff.attendance.adjustment.approve': 'Approve',
    'staff.attendance.adjustment.reject': 'Reject',
    'staff.attendance.adjustment.approveHint': 'to apply the changes',
    'staff.attendance.adjustment.rejectHint': 'to keep the original attendance times.',
    'staff.attendance.adjustment.rejectTitle': 'Reject request',
    'staff.attendance.adjustment.rejectReason': 'Rejection reason',
    'staff.attendance.adjustment.sentRequest': 'Submitted request',
    'staff.attendance.adjustment.status.pending': 'Pending approval',
    'staff.attendance.adjustment.status.approved': 'Approved',
    'staff.attendance.adjustment.status.rejected': 'Rejected',
    'staff.attendance.adjustment.rejectionReason': 'Rejection reason',
    'staff.attendance.adjustment.sendAgain': 'Submit again',
    'staff.attendance.adjustment.edit': 'Edit',
    'staff.attendance.adjustment.cancel': 'Cancel request',
    'staff.attendance.adjustment.status.cancelled': 'Cancelled',
    'staff.attendance.history.title': 'Change history',
    'staff.attendance.history.updatedBy': 'Updated by',
    'staff.attendance.history.empty': 'No change history.',
    'staff.attendance.history.managerDirect': 'Direct manager update',
    'staff.attendance.history.manager': 'Manager',
    'staff.attendance.history.approvedBy': 'Approved by',
    'staff.attendance.history.rejectedBy': 'Rejected by',
    'staff.attendance.history.requestedBy': 'Requested by',
    'staff.attendance.history.changeTime': 'Change time',
    'staff.attendance.errors.attendance_adjustment_self_only':
      'You can only request changes to your own attendance.',
    'staff.attendance.errors.attendance_adjustment_no_change':
      'The attendance time has not changed.',
    'staff.attendance.errors.attendance_adjustment_already_pending':
      'An adjustment request has already been submitted and is awaiting approval.',
    'staff.attendance.errors.attendance_adjustment_already_processed':
      'This adjustment request has already been processed.',
    'staff.attendance.monthly.unknownShift': 'Unknown shift',
    'staff.attendance.monthly.unsupported': 'Not supported',
    'staff.attendance.monthly.shiftLabel': 'Work shift',
    'staff.attendance.monthly.columns.date': 'Date',
    'staff.attendance.monthly.columns.weekday': 'Day',
    'staff.attendance.monthly.columns.type': 'Work schedule',
    'staff.attendance.monthly.columns.worked': 'Worked',
    'staff.attendance.monthly.columns.overtime': 'Overtime',
    'staff.attendance.monthly.columns.note': 'Reason/Note',
    'staff.attendance.monthly.columns.action': 'Action',
    'staff.attendance.monthly.dayType.future': 'Future date',
    'staff.attendance.monthly.dayType.missing_check_in': 'Missing check-in',
    'staff.attendance.monthly.dayType.missing_check_out': 'Missing check-out',
    'staff.attendance.monthly.dayType.working': 'Working',
    'staff.attendance.monthly.dayType.scheduled': 'Scheduled',
    'staff.attendance.monthly.dayType.no_schedule': 'No schedule',
    'staff.attendance.monthly.weekday.1': 'Monday',
    'staff.attendance.monthly.weekday.2': 'Tuesday',
    'staff.attendance.monthly.weekday.3': 'Wednesday',
    'staff.attendance.monthly.weekday.4': 'Thursday',
    'staff.attendance.monthly.weekday.5': 'Friday',
    'staff.attendance.monthly.weekday.6': 'Saturday',
    'staff.attendance.monthly.weekday.7': 'Sunday',
    'staff.attendance.monthly.summary.schedule': 'Monthly schedule',
    'staff.attendance.monthly.summary.result': 'Attendance result',
    'staff.attendance.monthly.summary.time': 'Time',
    'staff.attendance.monthly.metrics.scheduled_days': 'Scheduled days',
    'staff.attendance.monthly.metrics.no_schedule_days': 'Days without schedule',
    'staff.attendance.monthly.metrics.holiday_days': 'Holidays',
    'staff.attendance.monthly.metrics.attendance_days': 'Attendance days',
    'staff.attendance.monthly.metrics.complete_days': 'Complete days',
    'staff.attendance.monthly.metrics.actual_work_days': 'Actual workdays',
    'staff.attendance.monthly.metrics.missing_check_in_days': 'Missing check-in days',
    'staff.attendance.monthly.metrics.missing_check_out_days': 'Missing check-out days',
    'staff.attendance.monthly.metrics.worked_minutes': 'Total worked hours',
    'staff.attendance.monthly.metrics.overtime_minutes': 'Total overtime',
    'staff.attendance.monthly.metrics.late_minutes': 'Total late time',
    'staff.attendance.monthly.metrics.early_leave_minutes': 'Total early leave',
    'staff.attendance.monthly.metrics.missing_minutes': 'Total missing time',
    'staff.attendance.monthly.punch.type': 'Type',
    'staff.attendance.monthly.punch.time': 'Time',
    'staff.attendance.monthly.punch.accuracy': 'GPS accuracy',
    'staff.attendance.monthly.punch.distance': 'Distance',
    'staff.attendance.monthly.punch.network': 'Valid network',
    'staff.attendance.monthly.punch.location': 'Valid location',
  },
}
